<template>
  <div>
    <div name="header-title">
      <span class="m-list-title" for
        >operational and investment Finance plan PT.Infoglobal</span
      >
      <span class="m-list-title" for>Tahun : {{ head.year }}</span>
      <span class="m-list-title" for>Nama : {{ head.simulation_nm }}</span>
    </div>
    <div class="table-content">
      <div class="header-content">
        Scale : &nbsp;
        <a-radio-group button-style="solid" v-model="scale">
          <a-radio-button value="real">(1:1 Real)</a-radio-button>
          <a-radio-button value="juta">(1:1 Milion)</a-radio-button>
        </a-radio-group>
        <a-tooltip
          placement="topLeft"
          title="Download Excel"
          arrow-point-at-center
        >
          <a-button
            class="margin-left"
            icon="download"
            :loading="loadingExport"
            @click="handleExport"
          />
        </a-tooltip>

        <!--        <Export-->
        <!--          class="margin-left"-->
        <!--          :data="data"-->
        <!--          :title="exportConfig.title"-->
        <!--          name="exports.xls"-->
        <!--        />-->
      </div>
      <div class="content">
        <a-table
          bordered
          :loading="loadingtable"
          size="small"
          :columns="kolom"
          :data-source="data"
          :pagination="false"
          :indentSize="10"
          @expand="onExpand"
          checkable
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :scroll="{ x: longwidthTable, y: 450 }"
          :defaultExpandedRowKeys="defaultexpandedKeys"
          :defaultExpandAllRows="true"
        >
          <span slot="customTitleMain" style="vertical-align: middle">
            <b>FINANCE SIMULATION</b>
          </span>
          <span slot="customTitleThn">
            {{"YEAR " + head.year + (scale == "juta" ? (" (1:"+juta+")") :" (1:1)") }}
          </span>

          <span slot="name" slot-scope="name" style="vertical-align: middle">
            <b v-if="name.root === true">{{ name.nameitem }}</b>
            <span v-else>{{ name.nameitem }}</span>

            <!-- <a-popover
              :visible="popoverEditCodeCostCenter === name.key"
              :key="name.key"
              :id="name.key"
              placement="rightTop"
              trigger="click"
            >
              <a slot="title">
                <div class="m-display-flex space-between">
                  <span>Edit</span>
                  <span style="float:right;color:red;display:block" @click="closePopOver()"
                    >X</span
                  >
                </div> 
              </a>-->

            <a-button
              v-if="name.editable === true && allowtoEdit"
              @click="showPopOverEditCostcenter(name)"
              style="float: right; vertical-align: middle"
              size="small"
              type="dashed"
              shape="circle"
              icon="edit"
            />
            <!-- </a-popover> -->

            <a-button
              v-if="
                name.resetable === true &&
                allowtoEdit &&
                name.nameitem !== 'Hutang Tahun Berjalan'
              "
              @click="resetdataItem(name)"
              style="float: right; vertical-align: middle"
              size="small"
              type="dashed"
              shape="circle"
              icon="reload"
            >
            </a-button>
          </span>

          <span slot="dtlitemrekap" slot-scope="text,record">
            <span v-if="record.editable === true && allowtoEdit && false">{{
              formatRupiah(
                scale == "juta"
                  ? Math.round(text / juta) == -0
                    ? 0
                    : Math.round(text / juta)
                  : text
              )
                .replace("Rp", "")
                .replace(",00", "")
                .replace(/\s/g, "")
            }}
            </span>
            <b v-else>{{
            formatRupiah(
              scale == "juta"
                ? Math.round(text / juta) == -0
                  ? 0
                  : Math.round(text / juta)
                : text
            )
              .replace("Rp", "")
              .replace(",00", "")
              .replace(/\s/g, "")
            }}
            </b>
          </span>

          <span slot="dtlitem01" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem02" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem03" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem04" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(/\s/g, "")
                      .replace(",00", "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem05" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem06" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem07" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem08" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem09" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem10" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem11" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <span slot="dtlitem12" slot-scope="text, record">
            <editable-cell
              v-if="record.editable === true && allowtoEdit && false"
              :text="text[1] && text[1] !== null ? text[1].toString() : '0'"
              :scale="scale"
              :juta="juta"
              @change="onCellChange(record.key, text[0], $event)"
            />
            <span v-else>
              <b
                v-if="record.root == true"
                :style="text[1] < 0 ? 'color:red' : ''"
              >
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </b>
              <span v-else :style="text[1] < 0 ? 'color:red' : ''">
                <span
                  v-if="checkbalancebayar(record, text[0], text[1]) == 1"
                  style="border-bottom: 2px solid green; display: block"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span
                  v-else-if="checkbalancebayar(record, text[0], text[1]) == -1"
                  style="border-bottom: 2px solid red"
                >
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
                <span v-else>
                  {{
                    formatRupiah(
                      scale == "juta"
                        ? Math.round(text[1] / juta) == -0
                          ? 0
                          : Math.round(text[1] / juta)
                        : text[1]
                    )
                      .replace("Rp", "")
                      .replace(",00", "")
                      .replace(/\s/g, "")
                  }}
                </span>
              </span>
            </span>
          </span>
          <template slot="footer">
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Saldo Awal</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align m-text-bold"
                      :style="grandtotal.saldo_awal < 0 ? 'color:red' : ''"
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.saldo_awal,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
            </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Penerimaan Kas</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="grandtotal.total_debit < 0 ? 'color:red' : ''"
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.total_debit,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Pengeluaran Kas</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="grandtotal.total_credit < 0 ? 'color:red' : ''"
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.total_credit,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Hutang</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="grandtotal.hutang < 0 ? 'color:red' : ''"
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.hutang,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Saldo Sebelum Pendanaan</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align right m-text-bold"
                      :style="
                        grandtotal.saldo_sebelum_pendanaan < 0
                          ? 'color:red'
                          : ''
                      "
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.saldo_sebelum_pendanaan,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Pendanaan</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="grandtotal.pendanaan < 0 ? 'color:red' : ''"
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.pendanaan,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Saldo Setelah Pendanaan</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="
                        grandtotal.saldo_setelah_pendanaan < 0
                          ? 'color:red'
                          : ''
                      "
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(grandtotal.saldo_setelah_pendanaan,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
              </div>
            <div class="footer-calc">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
                  <span>Hutang Tahun Berikutnya</span>
                </a-col>
                <a-col :span="13">
                  <span
                      class="m-text-align left m-text-bold"
                      :style="
                        listTahun.hutang_tahun_berikutnya < 0 ? 'color:red' : ''
                      "
                    >
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="scalegrantotal(listTahun.hutang_tahun_berikutnya,scale,juta)"
                      />
                    </span>
                </a-col>
              </a-row>
            </div>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model="popupModalPendanaan.visible_pendanaan"
      title="Financing"
      :footer="null"
      :width="1000"
      :maskClosable="false"
    >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-card>
            <div slot="title">
              <span class="m-list-title" for>{{
                popupModalPendanaan.title
              }}</span>
              <span class="m-list-desc"
                >Year {{ popupModalPendanaan.year }}</span
              >
            </div>
            <a-form :form="formHeadPendanaan">
              <div class="m-display-flex space-between">
                <a-form-item label="Type">
                  <a-select
                    showSearch
                    placeholder="Type"
                    @change="modalPendanaanHeadChangeBank"
                    v-decorator="[
                      'typePendanaan',
                      {
                        rules: [{ required: true }],
                        initialValue: popupModalPendanaan.bank,
                      },
                    ]"
                    style="width: 120px"
                    class="m-width-full"
                    :disabled="popupModalPendanaan.dtlmode == 'add'"
                  >
                    <a-select-option
                      v-for="item in listtypependanaan"
                      :key="item.key"
                      :value="item.key"
                      >{{ item.lbl }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item label="Month">
                  <a-select
                    showSearch
                    placeholder="Month"
                    @change="modalPendanaanHeadChangeMonth"
                    v-decorator="[
                      'monthPendanaan',
                      {
                        rules: [{ required: true }],
                        initialValue: popupModalPendanaan.month,
                      },
                    ]"
                    style="width: 120px"
                    class="m-width-full"
                    :disabled="popupModalPendanaan.dtlmode == 'add'"
                  >
                    <a-select-option
                      v-for="item in listMonth"
                      :key="item.key"
                      >{{ item.month_nm }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </div>
              <a-form-item
                label="Bank Name"
                v-if="popupModalPendanaan.bank == 0"
              >
                <a-select
                  showSearch
                  allowClear
                  placeholder="Select Bank Name"
                  @change="modalPendanaanBankName"
                  v-decorator="[
                    'bankname',
                    {
                      rules: [{ required: true }],
                      initialValue: popupModalPendanaan.bankname,
                    },
                  ]"
                  class="m-width-full"
                  :disabled="popupModalPendanaan.dtlmode == 'add'"
                >
                  <a-select-option
                    v-for="item in listBank"
                    :key="item.id_bank_plafon"
                    :value="item.id_bank_plafon"
                    >{{ item.bank_nm }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item label="Plafon" v-if="popupModalPendanaan.bank == 0">
                <a-input-number
                  v-decorator="[
                    'val_plafon',
                    {
                      rules: [{ required: false }],
                    },
                  ]"
                  type="number"
                  class="m-width-full m-text-align-right"
                  :disabled="true"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  :min="0"
                ></a-input-number>
              </a-form-item>

              <a-form-item
                label="Remaining"
                v-if="popupModalPendanaan.bank == 0"
              >
                <a-input-number
                  v-decorator="[
                    'val_sisa',
                    {
                      rules: [{ required: false }],
                    },
                  ]"
                  type="number"
                  style="text-align: right !important"
                  class="m-width-full"
                  :disabled="true"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  :min="0"
                ></a-input-number>
              </a-form-item>
              <div style="display: none">
                <a-form-item label="Provisi">
                  <a-input-number
                    v-decorator="[
                      'val_provisi',
                      {
                        rules: [{ required: false }],
                        initialValue: popupModalPendanaan.provisi,
                      },
                    ]"
                    @change="modalPendanaanValueProvisi1"
                    type="number"
                    style="width: 70px !important; text-align: right !important"
                    class="m-width-full"
                    :disabled="popupModalPendanaan.dtlmode == 'add'"
                    :step="0.1"
                    :formatter="(value) => `${value}`.replace('.0', '')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    :min="0"
                    :max="100"
                  ></a-input-number>
                  % /
                  <span>{{
                    formatRupiah(
                      popupModalPendanaan.lblprovisi
                        ? popupModalPendanaan.lblprovisi
                        : 0
                    )
                  }}</span>
                </a-form-item>
              </div>
              <a-form-item label="Value">
                <a-input-number
                  v-decorator="[
                    'val_pendanaan',
                    {
                      rules: [{ required: true }],
                      initialValue: popupModalPendanaan.val,
                    },
                  ]"
                  @change="modalPendanaanValueProvisi2"
                  type="number"
                  class="m-width-full m-text-align-right"
                  :disabled="popupModalPendanaan.dtlmode == 'add'"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                  :min="0"
                ></a-input-number>
              </a-form-item>
              <span class="m-list-title">
                <b>
                  Total :
                  {{
                    formatRupiah(
                      popupModalPendanaan.valuebankreturn
                        ? popupModalPendanaan.valuebankreturn
                        : 0,
                      "IDR"
                    )
                  }}
                </b>
              </span>
              <a-divider class="margin-small" />
              <a-form-item label="Payment Type">
                <a-radio-group
                  v-decorator="[
                    'payment_type',
                    {
                      rules: [{ required: true }],
                      initialValue: popupModalPendanaan.payment_type,
                    },
                  ]"
                  :disabled="popupModalPendanaan.dtlmode == 'add'"
                  button-style="solid"
                >
                  <a-radio-button value="flat"> Flat </a-radio-button>
                  <a-radio-button value="prk"> Custom </a-radio-button>
                </a-radio-group>
              </a-form-item>
              <a-button
                type="primary"
                v-if="popupModalPendanaan.dtlmode == 'reset'"
                block
                @click="submitheadPendanaan"
                >Update</a-button
              >
            </a-form>
            <a-button
              type="primary"
              v-if="popupModalPendanaan.dtlmode == 'add'"
              block
              @click="resetheadPendanaan"
              >Reset</a-button
            >
          </a-card>
        </a-col>
        <a-col :span="16">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-card>
                <div slot="title">
                  <span class="m-list-title" for>Flat Payment Type</span>
                </div>
                <a-form :form="formDtlPendanaan" layout="horizontal">
                  <a-form-item
                    label="Duration"
                    :label-col="{ span: 7 }"
                    :wrapper-col="{ span: 8 }"
                  >
                    <a-input-number
                      @change="onChangeDuration"
                      :disabled="!popupModalPendanaan.isflat"
                      v-decorator="[
                        'duration',
                        { rules: [{ required: true }], initialValue: 0 },
                      ]"
                      :min="0"
                    />
                  </a-form-item>
                  <div class="m-display-flex space-between">
                    <a-form-item
                      label="Start"
                      :label-col="{ span: 9 }"
                      :wrapper-col="{ span: 8 }"
                    >
                      <a-select
                        showSearch
                        placeholder="Year"
                        v-decorator="[
                          'dtltahun',
                          {
                            rules: [{ required: true }],
                            initialValue: popupModalPendanaan.year,
                          },
                        ]"
                        style="width: 100px"
                        :disabled="!popupModalPendanaan.isflat"
                      >
                        <a-select-option
                          v-for="item in listtypetahun"
                          :key="item.key"
                          >{{ item.lbl }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item label="">
                      <a-select
                        showSearch
                        placeholder="Month"
                        v-decorator="[
                          'monthdtlPendanaan',
                          {
                            rules: [{ required: true }],
                            initialValue: popupModalPendanaan.month,
                          },
                        ]"
                        :disabled="!popupModalPendanaan.isflat"
                        style="width: 100px"
                      >
                        <a-select-option
                          v-for="item in listMonth"
                          :key="item.key"
                          >{{ item.month_nm }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <!-- <div class="m-display-flex space-between">
              <a-form-item label="End" v-if="!disabledEndDuration">
                <a-select
                  showSearch
                  placeholder="Year"
                  v-decorator="[
                    'dtltahun2',
                    {
                      rules: [{ required: true }],
                      initialValue: popupModalPendanaan.year,
                    },
                  ]"
                  style="width: 80px"
                  :disabled="popupModalPendanaan.dtlmode == 'reset'"
                >
                  <a-select-option
                    v-for="item in listtypetahun"
                    :key="item.key"
                    >{{ item.lbl }}</a-select-option
                  >
                </a-select>
              </a-form-item>
              <a-form-item label="" v-if="!disabledEndDuration">
                <a-select
                  showSearch
                  placeholder="Month2"
                  v-decorator="[
                    'monthdtlPendanaan2',
                    {
                      rules: [{ required: true }],
                      initialValue: popupModalPendanaan.month,
                    },
                  ]"
                  :disabled="popupModalPendanaan.dtlmode == 'reset'"
                  style="width: 80px"
                >
                  <a-select-option v-for="item in listMonth" :key="item.key">{{
                    item.month_nm
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              </div>  -->
                  <a-form-item
                    label="Value"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 8 }"
                  >
                    <a-input-number
                      v-decorator="[
                        'val_dtlbayar',
                        { rules: [{ required: true }], initialValue: 0 },
                      ]"
                      type="number"
                      :disabled="!popupModalPendanaan.isflat"
                      class="m-width-full m-text-align-right"
                      style="width: 213px"
                      :formatter="
                        (value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      :min="0"
                    ></a-input-number>
                  </a-form-item>
                  <a-button
                    type="primary"
                    block
                    :disabled="!popupModalPendanaan.isflat"
                    @click="submitDtlPendanaan"
                    >Change</a-button
                  >
                </a-form>
              </a-card>
            </a-col>
            <a-col :span="12">
              <a-card>
                <div slot="title">
                  <span class="m-list-title" for>Custom Payment Type</span>
                </div>
                <a-form :form="formDtlPendanaan2" layout="inline">
                  <div class="m-display-flex space-between">
                    <a-form-item
                      label="Period"
                      :label-col="{ span: 10 }"
                      :wrapper-col="{ span: 10 }"
                    >
                      <a-select
                        showSearch
                        placeholder="Year"
                        v-decorator="[
                          'dtltahun',
                          {
                            rules: [{ required: true }],
                            initialValue: popupModalPendanaan.year,
                          },
                        ]"
                        style="width: 85px"
                        :disabled="!popupModalPendanaan.isprk"
                      >
                        <a-select-option
                          v-for="item in listtypetahun"
                          :key="item.key"
                          >{{ item.lbl }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item label="">
                      <a-select
                        showSearch
                        placeholder="Select Month"
                        v-decorator="[
                          'monthdtlPendanaan',
                          {
                            rules: [{ required: true }],
                            initialValue: popupModalPendanaan.month,
                          },
                        ]"
                        :disabled="!popupModalPendanaan.isprk"
                        style="width: 85px"
                      >
                        <a-select-option
                          v-for="item in listMonth"
                          :key="item.key"
                          >{{ item.month_nm }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div style="display: none">
                    <a-form-item label="Interest Charge">
                      <a-input-number
                        @change="onChangeDuration"
                        :disabled="!popupModalPendanaan.isprk"
                        style="width: 133px"
                        v-decorator="[
                          'bunga',
                          { rules: [{ required: true }], initialValue: 0 },
                        ]"
                        :min="0"
                      />
                    </a-form-item>
                  </div>
                  <a-form-item
                    label="value"
                    :label-col="{ span: 5 }"
                    :wrapper-col="{ span: 10 }"
                  >
                    <a-input-number
                      @change="onChangeDuration"
                      :disabled="!popupModalPendanaan.isprk"
                      style="width: 215px"
                      type="number"
                      v-decorator="[
                        'val_dtlbayar',
                        { rules: [{ required: true }], initialValue: 0 },
                      ]"
                      :formatter="
                        (value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      "
                      :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                      :min="0"
                    />
                  </a-form-item>
                  <br />
                  <br />
                  <br />
                  <a-button
                    type="primary"
                    block
                    class="margin-top"
                    :disabled="!popupModalPendanaan.isprk"
                    @click="submitDtlPendanaan2"
                    >Change</a-button
                  >
                </a-form>
              </a-card>
            </a-col>
          </a-row>
          <a-card class="margin-top">
            <div slot="title">
              <span class="m-list-title" for>{{
                popupModalPendanaan.title3
              }}</span>
            </div>
            <a-table
              bordered
              size="small"
              :scroll="{ x: 100, y: 230 }"
              :pagination="false"
              :columns="columnsHutang"
              :loading="popupModalPendanaan.loadinglistbayar"
              :data-source="popupModalPendanaan.dataPembayaran"
            >
              <span slot="valueInterest" slot-scope="itemn">
                {{
                  itemn == undefined || itemn == null || itemn == 0
                    ? "-"
                    : itemn
                }}
              </span>
              <span slot="valueBayartable" slot-scope="itemn">
                {{
                  formatRupiah(itemn)
                    .replace("Rp", "")
                    .replace(" ", "")
                    .replace(",00", "")
                }}
              </span>
              <div
                slot="actionBayartable"
                style="align: center"
                slot-scope="item"
              >
                <!-- :visible="popoverEditCodeCostCenter==item.key"  -->
                <a-popover
                  :visible="popoverdtlpendanaan == item.key"
                  :key="item.key"
                  placement="leftTop"
                  trigger="hover"
                >
                  <!-- <a slot="title" style="float:right" @click="closePopOver()" >X</a> -->
                  <template slot="content">
                    <a-card>
                      <span slot="title">
                        {{item.bulan}}, {{item.tahun}}
                      </span>
                      <a-form-item>
                        <a-input-number 
                        class="m-width-full m-text-align right"
                        v-model="inputEditvalue" :min="0"/>
                      </a-form-item>
                      <a-button-group ghost block class="m-width-full m-text-align right">
                        <a-button type="primary" @click="simpanEditHutang()">
                          Save
                        </a-button>
                        <a-button type="danger" @click="cancelEditHutang()">
                          Cancel
                        </a-button>
                      </a-button-group>
                    </a-card>
                  </template>
                  </a-popover>
                  <a-button
                    size="small"
                    type="primary"
                    icon="edit"
                    @click="handleedithutang(item)"
                  />
                
                <a-button
                  size="small"
                  type="danger"
                  icon="close"
                  @click="handledeletehutang(item)"
                />
              </div>
            </a-table>
            <div>
              <span
                style="color: red; display: block"
                v-if="
                  popupModalPendanaan.totalPembayaran > 0 &&
                  popupModalPendanaan.totalPembayaran <
                    parseFloat(
                      popupModalPendanaan.bank == 0
                        ? popupModalPendanaan.valuebankreturn
                        : popupModalPendanaan.val
                    )
                "
              >
                * Total of payment is not equal with the Financing value
              </span>
              <span style="color: red; display: block" v-else> &nbsp; </span>
              <a-row :gutter="8" style="padding-top: 10px">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }"> </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <div class="m-display-flex space-between">
                    <span class="m-text-align left">Total Payment</span>
                    <span class="m-text-align left m-text-bold">
                      <CurrencyJustified
                        :currencyValue="'IDR'"
                        :valueNumber="popupModalPendanaan.totalPembayaran"
                      />
                    </span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-modal>
    <a-modal
      v-model="popupModalPendanaan.visible_saldo"
      title="Saldo"
      :footer="null"
      :width="500"
    >
      <a-form-item>
        <a-input
          v-model="editTextCostCenter"
          type="text"
          @pressEnter="simpanEditCostcenter()"
        />
        <a-input
          v-model="editCodeCostCenter"
          style="display: none"
          type="text"
        />
      </a-form-item>
      <a-button type="primary" @click="simpanEditCostcenter()" block>
        Save
      </a-button>
    </a-modal>

    <a-modal
      v-model="popupModalPendanaan.visible_saldoawal"
      title="Saldo"
      :footer="null"
      :width="500"
    >
      <a-form :form="formSaldoAwal">
        <ul class="m-list-wrapper bordered;display:block">
          <li>
            <span class="m-list-title" for>{{
              popupModalPendanaan.visible_title
            }}</span>
            <span class="m-list-desc">Year {{ head.year }}</span>
          </li>
        </ul>
        <a-form-item label="Month">
          <a-select
            showSearch
            placeholder="Month_saldoawal"
            readOnly
            v-decorator="[
              'month_saldoawal',
              { rules: [{ required: true }], initialValue: 0 },
            ]"
          >
            <a-select-option :key="0">Jan</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            v-decorator="[
              'val_saldoawal',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
          ></a-input-number>
        </a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          block
          @click="submitsaldoawal"
          >Save</a-button
        >
      </a-form>
    </a-modal>

    <a-modal
      v-model="popupModalPendanaan.visible_penerimaankas"
      title="Saldo"
      :footer="null"
      :width="500"
    >
      <a-form :form="formPenerimaanKas">
        <ul class="m-list-wrapper bordered;display:block">
          <li>
            <span class="m-list-title" for>{{
              popupModalPendanaan.visible_title
            }}</span>
            <span class="m-list-desc">Year {{ head.year }}</span>
          </li>
        </ul>
        <a-form-item label="Type">
          <a-select
            showSearch
            placeholder="Type"
            @change="handleType"
            style="width: 250px"
            v-decorator="[
              'typePenerimaanKas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option
              v-for="item in listtypepenerimaankas"
              :key="item.key"
              >{{ item.lbl }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Month">
          <a-select
            showSearch
            placeholder="Month"
            @change="handleMonth"
            v-decorator="[
              'monthPenerimaanKas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option v-for="item in listMonth" :key="item.key">{{
              item.month_nm
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Values">
          <a-input-number
            v-decorator="[
              'valpenerimaankas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
          ></a-input-number>
        </a-form-item>
      </a-form>
      <a-button
        type="primary"
        html-type="submit"
        block
        @click="submitpenerimaankas"
        >Save</a-button
      >
    </a-modal>

    <a-modal
      v-model="popupModalPendanaan.visible_pengeluarankas"
      title="Pengeluaran Kas"
      :footer="null"
      :width="400"
    >
      <a-form :form="formPengeluaranKas">
        <ul class="m-list-wrapper bordered;display:block">
          <li>
            <span class="m-list-title" for>{{
              popupModalPendanaan.visible_title
            }}</span>
            <span class="m-list-desc">Year {{ head.year }}</span>
          </li>
        </ul>
        <a-form-item label="Type Budget">
          <a-select
            showSearch
            placeholder="Type"
            @change="handleType"
            v-decorator="[
              'typePengeluaranKas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option :key="-1">All Type Budget</a-select-option>
            <a-select-option
              v-for="item in listtypepengeluarankas"
              :key="item.key"
              >{{ item.lbl }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="Month">
          <a-select
            showSearch
            placeholder="Select month"
            @change="handleMonth"
            v-decorator="[
              'monthPengeluaranKas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option :key="0">All Month</a-select-option>
            <a-select-option :key="1">January</a-select-option>
            <a-select-option :key="2">February</a-select-option>
            <a-select-option :key="3">Maret</a-select-option>
            <a-select-option :key="4">April</a-select-option>
            <a-select-option :key="5">May</a-select-option>
            <a-select-option :key="6">June</a-select-option>
            <a-select-option :key="7">July</a-select-option>
            <a-select-option :key="8">August</a-select-option>
            <a-select-option :key="9">September</a-select-option>
            <a-select-option :key="10">Oktober</a-select-option>
            <a-select-option :key="11">November</a-select-option>
            <a-select-option :key="12">December</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Type Change">
          <a-select
            showSearch
            placeholder="Type Change"
            v-decorator="[
              'typeChangePengeluaranKas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option :key="0">Increase</a-select-option>
            <a-select-option :key="1">Decrease</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Option Value">
          <a-radio-group
            v-decorator="[
              'option_value',
              { rules: [{ required: true }], initialValue: 'nominal' },
            ]"
            @change="handleOptionValuePengeluaranKas"
            button-style="solid"
          >
            <a-radio-button value="nominal"> Nominal </a-radio-button>
            <a-radio-button value="percentage"> Percentage </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="Nominal Value"
          v-if="popupModalPendanaan.optionValuePengeluaranKas == 'nominal'"
        >
          <a-input-number
            v-decorator="[
              'valnompengeluarankas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
          ></a-input-number>
        </a-form-item>
        <a-form-item
          label="Percentage Value"
          v-if="popupModalPendanaan.optionValuePengeluaranKas == 'percentage'"
        >
          <a-input-number
            v-decorator="[
              'valpengeluarankas',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
            :max="100"
          ></a-input-number>
          %
        </a-form-item>
      </a-form>
      <a-button
        type="primary"
        html-type="submit"
        block
        @click="submitpengeluarankas"
        >Change</a-button
      >
    </a-modal>

    <a-modal
      v-model="popupModalPendanaan.visible_hutang"
      title="Hutang"
      :footer="null"
      :width="500"
    >
      <a-form :form="formHutang">
        <ul class="m-list-wrapper bordered;display:block">
          <li>
            <span class="m-list-title" for>{{
              popupModalPendanaan.visible_title
            }}</span>
            <span class="m-list-desc">Year {{ head.year }}</span>
          </li>
        </ul>
        <a-form-item label="Type">
          <a-select
            showSearch
            placeholder="Type"
            @change="handleType"
            readOnly
            v-decorator="[
              'typeHutang',
              { rules: [{ required: true }], initialValue: 0 },
            ]"
          >
            <a-select-option v-for="item in listtypehutang" :key="item.key">{{
              item.lbl
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Month">
          <a-select
            showSearch
            placeholder="Month"
            readOnly
            v-decorator="[
              'month_hutang',
              { rules: [{ required: true }], initialValue: '' },
            ]"
          >
            <a-select-option v-for="item in listMonth" :key="item.key">{{
              item.month_nm
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Values">
          <a-input-number
            v-decorator="[
              'valhutang',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
          ></a-input-number>
        </a-form-item>
      </a-form>
      <a-button type="primary" html-type="submit" block @click="submithutang"
        >Change</a-button
      >
    </a-modal>

    <a-modal
      v-model="popupModalPendanaan.visible_other"
      title=" "
      :footer="null"
      :width="500"
    >
      <a-form :form="formSaldoAwal">
        <ul class="m-list-wrapper bordered;display:block">
          <li>
            <span class="m-list-title" for>{{
              popupModalPendanaan.visible_title
            }}</span>
            <span class="m-list-desc">Year {{ head.year }}</span>
          </li>
        </ul>
        <a-form-item label="Month">
          <a-select
            showSearch
            placeholder="Month_saldoawal"
            readOnly
            v-decorator="[
              'month_saldoawal',
              { rules: [{ required: true }], initialValue: 0 },
            ]"
          >
            <a-select-option :key="0">Jan</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Value">
          <a-input-number
            v-decorator="[
              'val_saldoawal',
              { rules: [{ required: true }], initialValue: '' },
            ]"
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            :min="0"
          ></a-input-number>
        </a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          block
          @click="submitsaldoawal"
          >Save</a-button
        >
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const columnsHutang = [
  {
    dataIndex: "no",
    key: "no",
    title: "No",
    width: 50,
    align: "right",
  },
  {
    dataIndex: "tahun",
    key: "tahun",
    title: "Year",
    width: 75,
    align: "center",
  },
  {
    dataIndex: "bulan",
    key: "bulan",
    title: "Month",
    width: 100,
  },
  // {
  //   dataIndex: "interest",
  //   key: "interest",
  //   title: "Interest",
  //   scopedSlots: { customRender: "valueInterest" },
  //   width: 100,
  // },
  {
    dataIndex: "value",
    key: "value",
    title: "Value",
    className: "editcell-wrap",
    scopedSlots: { customRender: "valueBayartable" },
    width: 175,
  },
  {
    key: "action",
    title: "Action",
    scopedSlots: { customRender: "actionBayartable" },
    width: 100,
  },
];

const dataHutang = [];

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div :class="editable ? 'unhidecell editable-cell-input-wrapper' : 'hidecell editable-cell-input-wrapper'">
          <a-input :value="value" className="editcell" class="editcell-wrap" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div :class="editable ? 'hidecell editable-cell-text-wrapper' : 'unhidecell editable-cell-text-wrapper'">
        
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
          {{ formatRupiah(scale == 'juta' ? value/juta :value).replace('Rp', '').replace(",00", "") || ' ' }}
          </span>
        </div>
      </div>
    `,
  props: {
    text: String,
    scale: String,
    juta: Number,
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      value: this.text,
      editable: false,
      form: null,
    };
  },
  beforeCreate() {},
  methods: {
    handleChange(e) {
      const value = e.target.value;
      this.value = value;
      this.$emit("editCell", this.value);
    },
    check() {
      this.editable = false;
      this.$emit("change", this.value);
    },
    edit() {
      this.editable = true;
    },
  },
};

import _ from "lodash";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import nanoid from "nanoid";
import axios from "axios";
import CryptoJS from "crypto-js";
//import Export from "@/components/iao-export-excel/Export.vue";

export default {
  name: "tableCustom",
  props: {
    source: {},
    column: {},
    datatree: {},
    listTahun: {},
    allowtoEdit: Boolean,
    head: {},
    urlExport: String,
  },
  components: {
    EditableCell,
    // Export
  },
  mixins: [CurrencyFormat],
  data() {
    return {
      loadingtable: false,
      columnsHutang,
      dataHutang,
      data: this.source,
      kolom: [],
      visible: false,
      suggestOpsiPeruntukan: {},
      expandedKeys: [],
      autoExpandParent: true,
      defaultexpandedKeys: [],
      editTextCostCenter: "",
      editCodeCostCenter: "",
      inputEditvalue: "",
      inputEditid: {},
      popoverEditCodeCostCenter: "",
      HeaderisClicked: "",
      listBank: [
        // { key: 1, bank_nm: "BRI-01xxxxx", plafon: 5000000, sisa:5000000 },
        // { key: 2, bank_nm: "BRI-02xxxxx", plafon: 8000000, sisa:8000000 },
      ],
      listMonth: [
        {
          key: 1,
          month_nm: "Jan",
        },
        { key: 2, month_nm: "Feb" },
        { key: 3, month_nm: "Mar" },
        { key: 4, month_nm: "Apr" },
        { key: 5, month_nm: "May" },
        { key: 6, month_nm: "Jun" },
        { key: 7, month_nm: "Jul" },
        { key: 8, month_nm: "Aug" },
        { key: 9, month_nm: "Sep" },
        { key: 10, month_nm: "Okt" },
        { key: 11, month_nm: "Nov" },
        { key: 12, month_nm: "Des" },
      ],
      scale: "real",
      juta: 1000000,
      popupModalPendanaan: {
        visible_pendanaan: false,
        visible_saldo: false,
        visible_saldoawal: false,
        visible_penerimaankas: false,
        visible_pengeluarankas: false,
        visible_hutang: false,
        visible_other: false,
        visible_title: "",
        visible_edit_bayar_dtl:false,
        loadinglistbayar: false,
        lblprovisi: 0,
        isflat: false,
        isprk: false,
        bankname: undefined,
        valuebankreturn: 0,
        optionValuePengeluaranKas: "nominal",
        payment_type: "flat",
      },
      disabledEndDuration: false,
      popoverdtlpendanaan: undefined,
      exportConfig: {
        title: [
          "OPERATIONAL AND INVESTMENT FINANCE PLAN PT.INFOGLOBAL",
          "TAHUN : 2021",
          "NAMA : UZAIR TEST",
          " ",
        ],
      },
      loadingExport: false,
      visibleFormPass: false,
      inputPassword: "",
    };
  },
  beforeCreate() {
    this.formDtlPendanaan = this.$form.createForm(this);
    this.formDtlPendanaan2 = this.$form.createForm(this);
    this.formHeadPendanaan = this.$form.createForm(this);
    this.formHutang = this.$form.createForm(this);
    this.formPengeluaranKas = this.$form.createForm(this);
    this.formPenerimaanKas = this.$form.createForm(this);
    this.formSaldoAwal = this.$form.createForm(this);
    this.formPassword = this.$form.createForm(this);
  },
  mounted() {
    this.HeaderisClicked = "rekap:hide;";
    this.listTahun.dtl.forEach((element) => {
      this.HeaderisClicked += element + ":unhide";
    });

    //create default list data pembayaran dengan nilai 0
    this.popupModalPendanaan.dataPembayaran = [];

    //create validator utang
    if (this.listTahun.validatorUtang == undefined) {
      this.listTahun.validatorUtang = [false];
    }

    //get list bank
    axios({
      method: "get",
      url: this.$serviceUrl + "simulasi/plafon",
      auth: {
        username: this.getAuth.username,
        password: this.getAuth.password,
      },
      headers: {
        "X-API-KEY": this.getAuth.apikey,
      },
      params: {
        tahun: this.head.year,
      },
    })
      .then((response) => {
        this.listBank = response.data.item_pp;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  created() {
    this.kolom = this.column;
    this.kolom[1].children_asal = this.kolom[1].children;
    this.defaultexpandedKeys.push(this.source[0].key);
    this.hitungallitem();
    var ready = require("document-ready");
    ready(function () {
      // //=> DOM is ready
    });
  },
  computed: {
    ...mapGetters(["getAuth"]),
    toptitle() {
      let lakhir = this.listTahun.dtl.length - 1;
      return (
        "Period " + this.listTahun.dtl[0] + " - " + this.listTahun.dtl[lakhir]
      );
    },
    longwidthTable() {
      let returns = 0;
      let iff = this.HeaderisClicked.split(";");
      if (iff[0] == "rekap:hide") {
        for (let x = 1; x < iff.length; x++) {
          let temp = iff[x].split(":");
          if (temp[1] == "unhide") {
            let calc = 12 * this.kolom[1].width + this.kolom[0].width;
            returns = calc;
          } else {
            returns = 200;
          }
        }
      } else {
        returns = parseInt(this.kolom[0].width);
      }
      return returns;
    },
    lookupmenu() {
      let iff = this.HeaderisClicked.split(";");
      let menu = [];

      iff.forEach((element) => {
        let el = element.split(":");
        let ai = { key: el[0], label: el[1], root: iff[0] };
        menu.push(ai);
      });
      return menu;
    },
    grandtotal() {
      let grandtotal = {
        saldo_awal: 0,
        total_debit: 0,
        hutang: 0,
        saldo_sebelum_pendanaan: 0,
        pendanaan: 0,
        saldo_setelah_pendanaan: 0,
      };
      this.source.forEach((element) => {
        if (element.nameitem == "Saldo Awal") {
          grandtotal.saldo_awal = element["rekap" + this.listTahun.dtl[0]];
        }
        if (element.nameitem == "Penerimaan Kas") {
          grandtotal.total_debit = element["rekap" + this.listTahun.dtl[0]];
        }
        if (element.nameitem == "Pengeluaran Kas") {
          grandtotal.total_credit = element["rekap" + this.listTahun.dtl[0]];
        }
        if (element.nameitem == "Hutang") {
          grandtotal.hutang = element["rekap" + this.listTahun.dtl[0]];
        }
        if (element.nameitem == "Saldo Sebelum Pendanaan") {
          grandtotal.saldo_sebelum_pendanaan =
            //element["rekap" + this.listTahun.dtl[0]];
            element["bln" + this.listTahun.dtl[0] + "12"][1];
        }
        if (element.nameitem == "Pendanaan") {
          grandtotal.pendanaan = element["rekap" + this.listTahun.dtl[0]];
        }
        if (element.nameitem == "Saldo Sesudah Pendanaan") {
          grandtotal.saldo_setelah_pendanaan =
            //element["rekap" + this.listTahun.dtl[0]];
            element["bln" + this.listTahun.dtl[0] + "12"][1];
        }
      });
      return grandtotal;
    },
    listtypepenerimaankas() {
      let result = {};
      this.source.forEach((element) => {
        if (element.nameitem == "Penerimaan Kas") {
          for (let y = 0; y < element.children.length; y++) {
            result[y] = { key: y, lbl: element.children[y].nameitem };
          }
        }
      });
      return result;
    },
    listtypepengeluarankas() {
      let result = {};
      this.source.forEach((element) => {
        if (element.nameitem == "Pengeluaran Kas") {
          for (let y = 0; y < element.children.length; y++) {
            result[y] = { key: y, lbl: element.children[y].nameitem };
          }
        }
      });
      return result;
    },
    listtypehutang() {
      let result = {};
      this.source.forEach((element) => {
        if (element.nameitem == "Hutang") {
          for (let y = 0; y < element.children.length; y++) {
            result[y] = { key: y, lbl: element.children[y].nameitem };
            break;
          }
        }
      });
      return result;
    },
    listtypependanaan() {
      let result = {};
      for (let z = 0; z < this.source.length; z++) {
        if (this.source[z].nameitem == "Pendanaan") {
          for (let y = 0; y < this.source[z].children.length; y++) {
            result[y] = { key: y, lbl: this.source[z].children[y].nameitem };
          }
        }
      }
      return result;
    },
    listtypetahun() {
      let result = {};
      let thn = parseInt(this.head.year);
      for (let y = 0; y < 10; y++) {
        result[y] = { key: thn, lbl: thn };
        thn = thn + 1;
      }
      return result;
    },
  },
  methods: {
    scalegrantotal(value,scale,jutaan){
     return (scale == "juta"
                ? Math.round(value / jutaan) < 0
                  ? 0
                  : Math.round(value / jutaan)
                : value
            )
    },
    handledeletehutang(val) {
      this.inputEditvalue = 0;
      this.inputEditid = val;
      this.popupModalPendanaan.loadinglistbayar = true;
      for (let ha = 0; ha < this.source.length; ha++) {
        if (this.source[ha].nameitem == "Pendanaan") {
          let lops = this.source[ha].children[this.popupModalPendanaan.bank][
            "children" +
              this.popupModalPendanaan.year +
              this.popupModalPendanaan.month
          ].length;
          for (let hb = 0; hb < lops; hb++) {
            if (
              this.source[ha].children[this.popupModalPendanaan.bank][
                "children" +
                  this.popupModalPendanaan.year +
                  this.popupModalPendanaan.month
              ][hb].nameitem == parseFloat(this.inputEditid.tahun)
            ) {
              let nm1 =
                "children" +
                this.popupModalPendanaan.year +
                this.popupModalPendanaan.month;
              this.source[ha].children[this.popupModalPendanaan.bank][nm1][hb][
                "bln" +
                  this.inputEditid.tahun +
                  this.inputEditid.key_bulan.toString()
              ][1] = this.inputEditvalue;
              this.hitungallitem();
              this.gentablebayar();
              this.popoverdtlpendanaan = null;
            }
          }
          // for (let hb = 0; hb < this.source[ha].children.length; hb++) {
          //   if (this.source[ha].children[hb].thn_bayar_hutang !== undefined) {
          //     for (
          //       let hc = 0;
          //       hc < this.source[ha].children[hb].thn_bayar_hutang.length;
          //       hc++
          //     ) {
          //       if(){

          //       }
          //     }
          //   }
          // }
        }
      }

      //check jumlah bayar hutang sama dengan jumlah hutang
      this.listTahun.validatorUtang[0] = this.validasipendanaan();

      //jika tahun bayar sama dengan tahun pembiayaan maka masuk hutang tahun berjalan
      let lops = [];
      for (let aa1 = 0; aa1 < this.source.length; aa1++) {
        if (this.source[aa1].nameitem === "Pendanaan") {
          for (let aa2 = 0; aa2 < this.source[aa1].children.length; aa2++) {
            if (
              this.source[aa1].children[aa2]["thn_bayar_hutang"] !== undefined
            ) {
              for (
                let aa3 = 0;
                aa3 < this.source[aa1].children[aa2]["thn_bayar_hutang"].length;
                aa3++
              ) {
                lops[Object.keys(lops).length] = {
                  root: aa1,
                  child: aa2,
                  lbl: this.source[aa1].children[aa2]["thn_bayar_hutang"][aa3],
                };
              }
            }
          }
        }
      }

      if (Object.keys(lops).length > 0) {
        //mencari lokasi hutang berjalan
        let lokhtg_root = undefined;
        let lokhtg_child = undefined;
        for (let ab1 = 0; ab1 < this.source.length; ab1++) {
          if (this.source[ab1].nameitem === "Hutang") {
            for (let ab2 = 0; ab2 < this.source[ab1].children.length; ab2++) {
              if (
                this.source[ab1].children[ab2].nameitem ==
                "Hutang Tahun Berjalan"
              ) {
                lokhtg_root = ab1;
                lokhtg_child = ab2;
              }
            }
          }
        }
        //menjumlah hutang perbulan tiap tahun pendanaan
        let longkeys = Object.keys(lops).length;
        for (let bb1 = 1; bb1 <= 12; bb1++) {
          let jumlahhtg = 0;
          for (let bb2 = 0; bb2 < longkeys; bb2++) {
            if (
              this.source[lops[bb2].root].children[lops[bb2].child][
                lops[bb2].lbl
              ] !== undefined
            ) {
              for (
                let bb3 = 0;
                bb3 <
                this.source[lops[bb2].root].children[lops[bb2].child][
                  lops[bb2].lbl
                ].length;
                bb3++
              ) {
                if (
                  this.source[lops[bb2].root].children[lops[bb2].child][
                    lops[bb2].lbl
                  ][bb3].nameitem == this.head.year
                ) {
                  let thntmp = this.source[lops[bb2].root].children[
                    lops[bb2].child
                  ][lops[bb2].lbl][bb3].nameitem;
                  jumlahhtg += parseFloat(
                    this.source[lops[bb2].root].children[lops[bb2].child][
                      lops[bb2].lbl
                    ][bb3]["bln" + thntmp + bb1][1]
                  );
                }
              }
            }
          }
          //entri value pada detil hutang
          this.source[lokhtg_root].children[lokhtg_child][
            "bln" + this.head.year + bb1
          ][1] = jumlahhtg;

          //entri value pada rekap hutang
          let longhtg2 = this.source[lokhtg_root].children.length;
          let jmlrhtg = 0;
          for (let cc1 = 0; cc1 < longhtg2; cc1++) {
            jmlrhtg += parseFloat(
              this.source[lokhtg_root].children[cc1][
                "bln" + this.head.year + bb1
              ][1]
            );
          }
          this.source[lokhtg_root]["bln" + this.head.year + bb1][1] = jmlrhtg;
        }
      }
      this.hitungallitem();

      this.popupModalPendanaan.loadinglistbayar = false;
    },
    cancelEditHutang(){
      this.popoverdtlpendanaan = null;
    },
    simpanEditHutang() {
      if (this.inputEditvalue==null){
        this.displayMessage("grather0")
        return;
      }
      this.popupModalPendanaan.loadinglistbayar = true;
      for (let ha = 0; ha < this.source.length; ha++) {
        if (this.source[ha].nameitem == "Pendanaan") {
          let lops = this.source[ha].children[this.popupModalPendanaan.bank][
            "children" +
              this.popupModalPendanaan.year +
              this.popupModalPendanaan.month
          ].length;
          for (let hb = 0; hb < lops; hb++) {
            let txtbnks = this.source[ha].children[this.popupModalPendanaan.bank][
                "children" +
                  this.popupModalPendanaan.year +
                  this.popupModalPendanaan.month
              ][hb].bankitem
            if (
              parseFloat(this.source[ha].children[this.popupModalPendanaan.bank][
                "children" +
                  this.popupModalPendanaan.year +
                  this.popupModalPendanaan.month
              ][hb].nameitem) == parseFloat(this.inputEditid.tahun) &&
              (txtbnks == undefined ? "undefined" : txtbnks) == 
                (this.popupModalPendanaan.bankname == undefined ? "undefined" :
                this.popupModalPendanaan.bankname)
            ) {
              let nm1 =
                "children" +
                this.popupModalPendanaan.year +
                this.popupModalPendanaan.month;
              this.source[ha].children[this.popupModalPendanaan.bank][nm1][hb][
                "bln" + this.inputEditid.tahun + this.inputEditid.key_bulan
              ][1] = this.inputEditvalue;
              this.hitungallitem();
              this.gentablebayar();
              this.popoverdtlpendanaan = null;
            }
          }
          // for (let hb = 0; hb < this.source[ha].children.length; hb++) {
          //   if (this.source[ha].children[hb].thn_bayar_hutang !== undefined) {
          //     for (
          //       let hc = 0;
          //       hc < this.source[ha].children[hb].thn_bayar_hutang.length;
          //       hc++
          //     ) {
          //       if(){

          //       }
          //     }
          //   }
          // }
        }
      }

      //check jumlah bayar hutang sama dengan jumlah hutang
      this.listTahun.validatorUtang[0] = this.validasipendanaan();

      //jika tahun bayar sama dengan tahun pembiayaan maka masuk hutang tahun berjalan
      let lops = [];
      for (let aa1 = 0; aa1 < this.source.length; aa1++) {
        if (this.source[aa1].nameitem === "Pendanaan") {
          for (let aa2 = 0; aa2 < this.source[aa1].children.length; aa2++) {
            if (
              this.source[aa1].children[aa2]["thn_bayar_hutang"] !== undefined
            ) {
              for (
                let aa3 = 0;
                aa3 < this.source[aa1].children[aa2]["thn_bayar_hutang"].length;
                aa3++
              ) {
                lops[Object.keys(lops).length] = {
                  root: aa1,
                  child: aa2,
                  lbl: this.source[aa1].children[aa2]["thn_bayar_hutang"][aa3],
                };
              }
            }
          }
        }
      }

      if (Object.keys(lops).length > 0) {
        //mencari lokasi hutang berjalan
        let lokhtg_root = undefined;
        let lokhtg_child = undefined;
        for (let ab1 = 0; ab1 < this.source.length; ab1++) {
          if (this.source[ab1].nameitem === "Hutang") {
            for (let ab2 = 0; ab2 < this.source[ab1].children.length; ab2++) {
              if (
                this.source[ab1].children[ab2].nameitem ==
                "Hutang Tahun Berjalan"
              ) {
                lokhtg_root = ab1;
                lokhtg_child = ab2;
              }
            }
          }
        }
        //menjumlah hutang perbulan tiap tahun pendanaan
        let longkeys = Object.keys(lops).length;
        for (let bb1 = 1; bb1 <= 12; bb1++) {
          let jumlahhtg = 0;
          for (let bb2 = 0; bb2 < longkeys; bb2++) {
            if (
              this.source[lops[bb2].root].children[lops[bb2].child][
                lops[bb2].lbl
              ] !== undefined
            ) {
              for (
                let bb3 = 0;
                bb3 <
                this.source[lops[bb2].root].children[lops[bb2].child][
                  lops[bb2].lbl
                ].length;
                bb3++
              ) {
                if (
                  this.source[lops[bb2].root].children[lops[bb2].child][
                    lops[bb2].lbl
                  ][bb3].nameitem == this.head.year
                ) {
                  let thntmp = this.source[lops[bb2].root].children[
                    lops[bb2].child
                  ][lops[bb2].lbl][bb3].nameitem;
                  jumlahhtg += parseFloat(
                    this.source[lops[bb2].root].children[lops[bb2].child][
                      lops[bb2].lbl
                    ][bb3]["bln" + thntmp + bb1][1]
                  );
                }
              }
            }
          }
          //entri value pada detil hutang
          this.source[lokhtg_root].children[lokhtg_child][
            "bln" + this.head.year + bb1
          ][1] = jumlahhtg;

          //entri value pada rekap hutang
          let longhtg2 = this.source[lokhtg_root].children.length;
          let jmlrhtg = 0;
          for (let cc1 = 0; cc1 < longhtg2; cc1++) {
            jmlrhtg += parseFloat(
              this.source[lokhtg_root].children[cc1][
                "bln" + this.head.year + bb1
              ][1]
            );
          }
          this.source[lokhtg_root]["bln" + this.head.year + bb1][1] = jmlrhtg;
        }
      }
      this.hitungallitem();
      this.popupModalPendanaan.loadinglistbayar = false;
      this.popupModalPendanaan.visible_edit_bayar_dtl = false
    },
    handleedithutang(val) {
      this.inputEditvalue = val.value;
      this.inputEditid = val;
      this.popoverdtlpendanaan = val.key;
      this.popupModalPendanaan.visible_edit_bayar_dtl = true;
    },
    onChangeDuration(val) {
      if (val > 0) {
        this.disabledEndDuration = true;
      } else {
        this.disabledEndDuration = false;
      }
    },
    gethutangberjalan(year, month) {
      let htgsblm = 0;
      var tloop = [];
      for (let ha = 0; ha < this.source.length; ha++) {
        if (this.source[ha].nameitem == "Pendanaan") {
          for (let hb = 0; hb < this.source[ha].children.length; hb++) {
            if (this.source[ha].children[hb].thn_bayar_hutang !== undefined) {
              for (
                let hc = 0;
                hc < this.source[ha].children[hb].thn_bayar_hutang.length;
                hc++
              ) {
                tloop.push({
                  a1: ha,
                  a2: hb,
                  a3: this.source[ha].children[hb].thn_bayar_hutang[hc],
                });
              }
            }
          }
        }
      }
      for (let ha = 0; ha < tloop.length; ha++) {
        let jb = this.source[tloop[ha].a1].children[tloop[ha].a2][tloop[ha].a3]
          .length;
        for (let hb = 0; hb < jb; hb++) {
          let thns = this.source[tloop[ha].a1].children[tloop[ha].a2][
            tloop[ha].a3
          ][hb];
          if (year == thns.nameitem) {
            let head1 = 0;
            let head2 = 0;
            for (let ha1 = 0; ha1 < this.source.length; ha1++) {
              if (this.source[ha1].nameitem == "Hutang") {
                head1 = ha1;
                for (
                  let ha2 = 0;
                  ha2 < this.source[ha1].children.length;
                  ha2++
                ) {
                  if (
                    this.source[ha1].children[ha2].nameitem ==
                    "Hutang Tahun Berjalan"
                  ) {
                    head2 = ha2;
                  }
                }
              }
            }
            for (let iter = 1; iter <= 12; iter++) {
              this.source[head1].children[head2][
                "bln" + year.toString() + iter
              ][1] = thns["bln" + year.toString() + iter][1];
            }
            htgsblm += this.source[tloop[ha].a1].children[tloop[ha].a2][
              tloop[ha].a3
            ][hb]["bln" + year + month][1];
          }
        }
      }
      return htgsblm;
    },
    checkbalancebayar(record, text, val) {
      let result = 0;
      let te = text.replace("bln", "children");
      if (record[te] != undefined) {
        let valuesbank = record[text][3].split(";")
        let valuesnom = record[text][6].split(";")
        
        let jbyr = record[te].length;
        for (let h = 0; h < Object.keys(valuesbank).length-1; h++) {
          let total = 0;
          for (let i = 0; i < jbyr; i++) {
            let thn = record[te][i].nameitem 
            let bnk = record[te][i].bankitem == undefined ? "undefined" : record[te][i].bankitem;
            if (bnk==valuesbank[h]){
              for (let j = 1; j <= 12; j++) {
                //console.log(te,i,thn,j,record)
                total += parseInt(record[te][i]["bln" + thn + j][1]);
              }
            }
          }
          if (total < (isNaN(parseInt(valuesnom[h])) ? 0 : parseInt(valuesnom[h]))) {
            result = -1;
            break
            
          } else if (total >(isNaN(parseInt(valuesnom[h])) ? 0 : parseInt(valuesnom[h]))) {
            result = 1;
          }
        }
      } else if (
        (record.nameitem == "Bank" || record.nameitem == "Non Bank") &&
        parseFloat(val) !== 0
      ) {
        result = -1;
      }
      return result;
    },
    validasipendanaan() {
      //untuk cek apakah jumlah value detil pendanaan sesuai dengan value pendanaan
      let vsts = true;
      for (let ha = 0; ha < this.source.length; ha++) {
        if (this.source[ha].nameitem == "Pendanaan") {
          for (let hb = 0; hb < this.source[ha].children.length; hb++) {
            let vhtg = 0;
            if (this.source[ha].children[hb].thn_bayar_hutang !== undefined) {
              let jhtg = this.source[ha].children[hb].thn_bayar_hutang.length;
              for (let hc = 0; hc < jhtg; hc++) {
                vhtg = 0;
                if (
                  this.source[ha].children[hb][
                    this.source[ha].children[hb].thn_bayar_hutang[hc]
                  ]
                ) {
                  let jhtg2 = this.source[ha].children[hb][
                    this.source[ha].children[hb].thn_bayar_hutang[hc]
                  ].length;
                  for (let hd = 0; hd < jhtg2; hd++) {
                    let nmitem = this.source[ha].children[hb][
                      this.source[ha].children[hb].thn_bayar_hutang[hc]
                    ][hd].nameitem;

                    let itmnm = this.source[ha].children[hb].thn_bayar_hutang[
                      hc
                    ].replace("children", "bln");

                    let cbank = this.source[ha].children[hb][itmnm][6].split(";")

                      for (let he = 1; he <= 12; he++) {
                        vhtg += parseFloat(
                          this.source[ha].children[hb][
                            this.source[ha].children[hb].thn_bayar_hutang[hc]
                          ][hd]["bln" + nmitem + he][1]
                        );
                      }
                    
                    if (
                      parseFloat(cbank[hd]) > vhtg
                    ) {
                      vsts = false;
                      break
                    }
                    vhtg = 0
                  }
                }
                if (vsts == false){
                  break
                }
              }
              if (vsts == false){
                  break
                }
            } else {
              //mencari pendanaan yang tidak mempunyai detil pembayaran
              for (let he = 1; he <= 12; he++) {
                if (
                  parseFloat(
                    this.source[ha].children[hb]["bln" + this.head.year + he][1]
                  ) > 0
                ) {
                  vsts = false;
                  break
                }
              }
            }
            vhtg = 0;
          }
        }
      }
      return vsts;
    },
    modalPendanaanHeadChangeBank(value) {
      let form = this.formHeadPendanaan.getFieldsValue();
      this.source.forEach((element) => {
        if (element.nameitem == "Pendanaan") {
          //mencari data posisi id bank
          let al1 =
            element.children[value][
              "bln" + this.head.year + form.monthPendanaan
            ][3];
          let al2 =
            element.children[value][
              "bln" + this.head.year + form.monthPendanaan
            ][4];
          let al3 =
            element.children[value][
              "bln" + this.head.year + form.monthPendanaan
            ][5];
          let al4 =
            element.children[value][
              "bln" + this.head.year + form.monthPendanaan
            ][6];
          let val3,
            val4,
            val5,
            val6 = 0;
          if (al1 !== undefined) {
            val3 = al1.split(";");
            val3 = val3[0];
            val4 = al2.split(";");
            val4 = val4[0];
            val5 = al3.split(";");
            val5 = val5[0];
            val6 = al4.split(";");
            val6 = val6[0];
          } else {
            val3 = al1;
            val4 = al2;
            val5 = al3;
            val6 = al4;
          }
          if (
            Object.keys(
              element.children[value][
                "bln" + this.head.year + form.monthPendanaan
              ]
            ).length > 4
          ) {
            if (element.children[value].nameitem == "Bank") {
              this.$nextTick(function () {
                this.formHeadPendanaan.setFieldsValue({
                  val_pendanaan: val6,
                  bankname: val3 ? val3 : undefined,
                  val_provisi: val4 ? val4 : 0,
                  val_plafon: 0,
                  val_sisa: 0,
                });
              });
              this.displayheadvalue(value, form.monthPendanaan, val3);
            } else {
              this.$nextTick(function () {
                this.formHeadPendanaan.setFieldsValue({
                  val_pendanaan: val6,
                  val_provisi: val4 ? val4 : 0,
                  payment_type: val5 == "2" ? "prk" : "flat",
                });
              });
            }

            let provs = ((val4 ? val4 : 0) * val6) / 100;
            this.popupModalPendanaan.provisi = val4 ? val4 : 0;
            this.popupModalPendanaan.lblprovisi = provs;
            this.popupModalPendanaan.valuebankreturn = parseFloat(val6) + provs;
            this.popupModalPendanaan.payment_type = val5 == 2 ? "prk" : "flat";
          } else {
            this.$nextTick(function () {
              this.formHeadPendanaan.setFieldsValue({
                val_pendanaan: val6,
                bankname: val3 ? val3 : undefined,
                val_provisi: val4 ? val4 : 0,
                payment_type: val5 == "2" ? "prk" : "flat",
              });
            });
            this.popupModalPendanaan.lblprovisi = 0;
            this.popupModalPendanaan.valuebankreturn = 0;
          }

          this.popupModalPendanaan.bank = value;
          this.popupModalPendanaan.bankname = (val3 == "undefined" ? undefined : val3)
          this.popupModalPendanaan.month = form.monthPendanaan;
          this.popupModalPendanaan.val = val6;
          this.popupModalPendanaan.dtlmode = "reset";
        }
      });
      this.gentablebayar();
    },
    displayheadvalue(bank, month, bankname) {
      this.popupModalPendanaan.bankname = bankname;
      this.source.forEach((element) => {
        if (element.nameitem == "Pendanaan") {
          let valbnk =
            element.children[bank]["bln" + this.head.year + month][3];

          let splitbnk = valbnk ? valbnk.split(";") : undefined;
          bankname = bankname ? bankname.toString() : "undefined";
          let canproc = false;
          let keybank = 0;
          let flop = 0;
          if (splitbnk == undefined && bankname == undefined) {
            canproc = false;
          }
          if (splitbnk !== undefined) {
            splitbnk.forEach((elements) => {
              if (elements == bankname) {
                canproc = true;
                keybank = flop;
              } else if (elements == "undefined") {
                canproc = true;
                keybank = null;
              }
              flop++;
            });
          }
          if (canproc && keybank !== null) {
            let totlslop = 0;
            let slop =
              element.children[bank][
                "bln" + this.head.year + month.toString()
              ][3];
            slop = slop ? slop.split(";") : undefined;
            if (slop !== undefined) {
              let wg = 0;
              slop.forEach((ement) => {
                if (ement !== undefined && ement == bankname.toString()) {
                  let slops =
                    element.children[bank][
                      "bln" + this.head.year + month.toString()
                    ][6];
                  slops = slops.split(";");
                  totlslop += parseFloat(slops[wg]);
                }
                wg++;
              });
            }
            // if(element.children[bank]["children" + this.head.year + month][
            //   yslop].bankitem == bankname
            // ){
            //   // let tyear = element.children[bank]["children" + this.head.year + month][
            //   // yslop].nameitem
            //   // for (let zslop = 1; zslop <= 12; zslop++) {
            //   //   totlslop+=element.children[bank]["children" + this.head.year + month][
            //   // yslop]["bln"+ tyear +zslop.toString()][1]
            //   // console.log("totlslop",element.children[bank]["children" + this.head.year + month][
            //   // yslop],"bln"+ tyear +zslop.toString(),totlslop)
            //   // }
            // }

            let splitprovisi = element.children[bank][
              "bln" + this.head.year + month
            ][4].split(";");

            let splittypebyr = element.children[bank][
              "bln" + this.head.year + month
            ][5].split(";");

            this.$nextTick(function () {
              this.formHeadPendanaan.setFieldsValue({
                val_pendanaan: totlslop,
                val_provisi: splitprovisi[keybank],
                payment_type: splittypebyr[keybank] == "2" ? "prk" : "flat",
              });
            });

            this.popupModalPendanaan.provisi = splitprovisi[keybank];
            this.popupModalPendanaan.bank = bank;
            this.popupModalPendanaan.bankname = (bankname == "undefined" ? undefined : bankname.toString())
            this.popupModalPendanaan.month = month;
            this.popupModalPendanaan.val = totlslop;

            let prov =
              (this.popupModalPendanaan.val *
                this.popupModalPendanaan.provisi) /
              100;
            this.popupModalPendanaan.lblprovisi = prov;
            this.popupModalPendanaan.valuebankreturn =
              parseFloat(prov) + parseFloat(this.popupModalPendanaan.val);
            this.gentablebayar();
          } else if (canproc && keybank == null) {
            let splitprovisi = element.children[bank][
              "bln" + this.head.year + month
            ][4].split(";");

            let splittypebyr = element.children[bank][
              "bln" + this.head.year + month
            ][5].split(";");

            this.$nextTick(function () {
              this.formHeadPendanaan.setFieldsValue({
                val_pendanaan:
                  element.children[bank]["bln" + this.head.year + month][1],
                val_provisi: splitprovisi[0],
                payment_type: splittypebyr[0] == "2" ? "prk" : "flat",
              });
            });

            this.popupModalPendanaan.provisi = splitprovisi[0];
            this.popupModalPendanaan.bank = bank;
            this.popupModalPendanaan.bankname = (bankname == "undefined" ? undefined : bankname.toString())
            this.popupModalPendanaan.month = month;
            this.popupModalPendanaan.val =
              element.children[bank]["bln" + this.head.year + month][1];

            let prov =
              (this.popupModalPendanaan.val *
                this.popupModalPendanaan.provisi) /
              100;
            this.popupModalPendanaan.lblprovisi = prov;
            this.popupModalPendanaan.valuebankreturn =
              parseFloat(prov) + parseFloat(this.popupModalPendanaan.val);
            this.gentablebayar();
          } else {
            this.$nextTick(function () {
              this.formHeadPendanaan.setFieldsValue({
                val_pendanaan: 0,
                val_provisi: 0,
                payment_type: "flat",
              });
            });
            this.popupModalPendanaan.provisi = 0;
            this.popupModalPendanaan.bank = this.popupModalPendanaan.bank
              ? this.popupModalPendanaan.bank
              : 0;
            this.popupModalPendanaan.month = this.popupModalPendanaan.month
              ? this.popupModalPendanaan.month
              : 1;
            this.popupModalPendanaan.bankname = undefined
            this.popupModalPendanaan.val = 0;
            this.popupModalPendanaan.valuebankreturn = 0;
            this.popupModalPendanaan.lblprovisi = 0;
            this.popupModalPendanaan.totalPembayaran = 0;
          }
          this.popupModalPendanaan.dtlmode = "reset";
        }
      });

      //menghitung sisa remaining plafon
      let sisaplafon = 0;
      for (let hax = 0; hax < this.source.length; hax++) {
        if (this.source[hax].nameitem == "Pendanaan") {
          for (let hb = 0; hb < this.source[hax].children.length; hb++) {
            if (this.source[hax].children[hb].nameitem == "Bank") {
              for (let ab = 1; ab <= 12; ab++) {
                if (
                  this.source[hax].children[hb]["bln" + this.head.year + ab][3]
                ) {
                  if (
                    this.source[hax].children[hb][
                      "bln" + this.head.year + ab
                    ][3].indexOf(bankname.toString()) >= 0
                  ) {
                    let txblb = this.source[hax].children[hb][
                      "bln" + this.head.year + ab
                    ][3];
                    txblb = txblb ? txblb.split(";") : undefined;
                    if (txblb !== undefined) {
                      let wg = 0;
                      txblb.forEach((element) => {
                        if (
                          element !== undefined &&
                          element == bankname.toString()
                        ) {
                          let isval = this.source[hax].children[hb][
                            "bln" + this.head.year + ab
                          ][6].split(";");
                          sisaplafon += parseFloat(isval[wg]);
                        }
                        wg++;
                      });
                    }
                  }
                }
              }
            }
          }
        }
      }

      if (bankname !== "undefined" && bankname !== undefined) {
        let index_1 = _.filter(this.listBank, { id_bank_plafon: bankname });
        this.$nextTick(function () {
          this.formHeadPendanaan.setFieldsValue({
            val_plafon: parseFloat(index_1[0].value),
            val_sisa:
              parseFloat(index_1[0].value) -
              (sisaplafon - this.popupModalPendanaan.val),
          });
        });
      }
    },
    modalPendanaanBankName(value) {
      this.popupModalPendanaan.dataPembayaran = [];
      let isiform = this.formHeadPendanaan.getFieldsValue();
      let form = {};
      if (isiform.length == undefined) {
        form = {
          bankname: this.popupModalPendanaan.bankname,
          monthPendanaan: this.popupModalPendanaan.month,
          typePendanaan: this.popupModalPendanaan.bank,
          val_pendanaan: this.popupModalPendanaan.val,
          payment_type: this.popupModalPendanaan.payment_type,
          val_plafon: 0,
          val_provisi: this.popupModalPendanaan.provisi,
          val_sisa: 0,
        };
      } else {
        form = isiform;
      }

      this.displayheadvalue(form.typePendanaan, form.monthPendanaan, value);
    },
    modalPendanaanValueProvisi1(value) {
      let form = this.formHeadPendanaan.getFieldsValue();
      let prov = (value * form.val_pendanaan) / 100;
      this.popupModalPendanaan.lblprovisi = prov;
      this.popupModalPendanaan.valuebankreturn =
        parseFloat(prov) + parseFloat(form.val_pendanaan);
    },
    modalPendanaanValueProvisi2(value) {
      let form = this.formHeadPendanaan.getFieldsValue();
      let prov = (value * form.val_provisi) / 100;
      this.popupModalPendanaan.lblprovisi = prov;
      this.popupModalPendanaan.valuebankreturn =
        parseFloat(prov) + parseFloat(value);
    },
    modalPendanaanHeadChangeMonth(value) {
      let form = this.formHeadPendanaan.getFieldsValue();
      this.source.forEach((element) => {
        if (element.nameitem == "Pendanaan") {
          //mencari data posisi id bank
          let al1 =
            element.children[form.typePendanaan][
              "bln" + this.head.year + value
            ][3];
          let al2 =
            element.children[form.typePendanaan][
              "bln" + this.head.year + value
            ][4];
          let al3 =
            element.children[form.typePendanaan][
              "bln" + this.head.year + value
            ][5];
          let al4 =
            element.children[form.typePendanaan][
              "bln" + this.head.year + value
            ][6];
          let val3,
            val4,
            val5,
            val6 = 0;
          if (al1 !== undefined) {
            val3 = al1.split(";");
            val3 = val3[0];
            val4 = al2.split(";");
            val4 = val4[0];
            val5 = al3.split(";");
            val5 = val5[0];
            val6 = al4.split(";");
            val6 = val6[0];
          } else {
            val3 = al1;
            val4 = al2;
            val5 = al3;
            val6 = al4;
          }

          this.formHeadPendanaan.setFieldsValue({
            val_pendanaan: val6,
            val_provisi: val4 ? val4 : 0,
            payment_type: val5 == "2" ? "prk" : "flat",
          });
          if (form.typePendanaan == 0) {
            this.formHeadPendanaan.setFieldsValue({
              bankname: val3 ? val3 : undefined,
              val_plafon: 0,
              val_sisa: 0,
            });
          }

          if (val3) {
            this.displayheadvalue(form.typePendanaan, value, val3);
          } else {
            let provs = ((val4 ? val4 : 0) * val6) / 100;
            this.popupModalPendanaan.provisi = val4 ? val4 : 0;
            this.popupModalPendanaan.lblprovisi = provs;
            this.popupModalPendanaan.valuebankreturn = parseFloat(val6) + provs;
            this.popupModalPendanaan.payment_type = val5 == 2 ? "prk" : "flat";

            this.popupModalPendanaan.bank = form.typePendanaan;
            this.popupModalPendanaan.bankname = undefined;
            this.popupModalPendanaan.month = value;
            this.popupModalPendanaan.val =
              element.children[form.typePendanaan][
                "bln" + this.head.year + value
              ][1];
          }
          this.popupModalPendanaan.dtlmode = "reset";
        }
      });
      this.gentablebayar();
    },
    submitsaldoawal() {
      this.formSaldoAwal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        for (let y = 0; y < this.source.length; y++) {
          if (this.source[y].nameitem == "Saldo Awal") {
            this.source[y][
              "bln" + this.head.year + (values.month_saldoawal + 1)
            ][1] = values.val_saldoawal;
          }
        }
        this.hitungallitem();
      });
      this.popoverEditCodeCostCenter = "";
      this.popupModalPendanaan.visible_other = false;
      this.formSaldoAwal.resetFields();
    },
    submitpenerimaankas() {
      this.formPenerimaanKas.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        for (let y = 0; y < this.source.length; y++) {
          if (this.source[y].nameitem === "Penerimaan Kas") {
            let temp = 0;
            this.source[y].children[values.typePenerimaanKas][
              "bln" + this.head.year + values.monthPenerimaanKas
            ][1] = values.valpenerimaankas;
            for (let z = 0; z < this.source[y].children.length; z++) {
              temp += parseFloat(
                this.source[y].children[z][
                  "bln" + this.head.year + values.monthPenerimaanKas
                ][1]
              );
            }
            this.source[y][
              "bln" + this.head.year + values.monthPenerimaanKas
            ][1] = temp;
            break;
          }
        }

        this.hitungallitem();
      });
      this.popoverEditCodeCostCenter = "";
      this.popupModalPendanaan.visible_penerimaankas = false;
      this.formPenerimaanKas.resetFields();
    },
    submitpengeluarankas() {
      this.formPengeluaranKas.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        for (let y = 0; y < this.source.length; y++) {
          if (this.source[y].nameitem === "Pengeluaran Kas") {
            if (values.typePengeluaranKas == -1) {
              for (let z = 0; z < this.source[y].children.length; z++) {
                if (values.option_value == "percentage") {
                  if (values.monthPengeluaranKas == 0) {
                    for (let x = 1; x <= 12; x++) {
                      if (values.typeChangePengeluaranKas == 0) {
                        this.source[y].children[z][
                          "bln" + this.head.year + x
                        ][1] =
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          ) *
                            (values.valpengeluarankas / 100) +
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          );
                      } else {
                        let tolklr =
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          ) -
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          ) *
                            (values.valpengeluarankas / 100);

                        this.source[y].children[z][
                          "bln" + this.head.year + x
                        ][1] = tolklr < 0 ? 0 : tolklr;
                      }
                    }
                  } else {
                    if (values.typeChangePengeluaranKas == 0) {
                      this.source[y].children[z][
                        "bln" + this.head.year + values.monthPengeluaranKas
                      ][1] =
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        ) *
                          (values.valpengeluarankas / 100) +
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        );
                    } else {
                      let totklr =
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        ) -
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        ) *
                          (values.valpengeluarankas / 100);
                      this.source[y].children[z][
                        "bln" + this.head.year + values.monthPengeluaranKas
                      ][1] = totklr < 0 ? 0 : totklr;
                    }
                  }
                } else {
                  if (values.monthPengeluaranKas == 0) {
                    for (let x = 1; x <= 12; x++) {
                      if (values.typeChangePengeluaranKas == 0) {
                        this.source[y].children[z][
                          "bln" + this.head.year + x
                        ][1] =
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          ) + values.valnompengeluarankas;
                      } else {
                        let totklr =
                          parseFloat(
                            this.source[y].children[z][
                              "bln" + this.head.year + x
                            ][1]
                          ) - values.valnompengeluarankas;
                        this.source[y].children[z][
                          "bln" + this.head.year + x
                        ][1] = totklr < 0 ? 0 : totklr;
                      }
                    }
                  } else {
                    if (values.typeChangePengeluaranKas == 0) {
                      this.source[y].children[z][
                        "bln" + this.head.year + values.monthPengeluaranKas
                      ][1] =
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        ) + values.valnompengeluarankas;
                    } else {
                      let totklr =
                        parseFloat(
                          this.source[y].children[z][
                            "bln" + this.head.year + values.monthPengeluaranKas
                          ][1]
                        ) - values.valnompengeluarankas;
                      this.source[y].children[z][
                        "bln" + this.head.year + values.monthPengeluaranKas
                      ][1] = totklr < 0 ? 0 : totklr;
                    }
                  }
                }
              }
              //menghitung rekap pengeluaran
              let temp = 0;
              if (values.monthPengeluaranKas == 0) {
                for (let c = 1; c <= 12; c++) {
                  for (let z = 0; z < this.source[y].children.length; z++) {
                    temp += parseFloat(
                      this.source[y].children[z]["bln" + this.head.year + c][1]
                    );
                  }
                  this.source[y]["bln" + this.head.year + c][1] = temp;
                  temp =0
                }
              } else {
                for (let z = 0; z < this.source[y].children.length; z++) {
                  temp += parseFloat(
                    this.source[y].children[z][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1]
                  );
                }
                this.source[y][
                  "bln" + this.head.year + values.monthPengeluaranKas
                ][1] = temp;
                temp = 0
              }
            } else {
              //###########################################
              if (values.monthPengeluaranKas == 0) {
                for (let c = 1; c <= 12; c++) {
                  if (values.typeChangePengeluaranKas == 0) {
                    if (values.option_value == "percentage") {
                      this.source[y].children[values.typePengeluaranKas][
                        "bln" + this.head.year + c
                      ][1] =
                        parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        ) *
                          (values.valpengeluarankas / 100) +
                        parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        );
                    } else {
                      this.source[y].children[values.typePengeluaranKas][
                        "bln" + this.head.year + c
                      ][1] =
                        parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        ) + values.valnompengeluarankas;
                    }
                  } else {
                    if (values.option_value == "percentage") {
                      let totkl = parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        ) -
                        parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        ) *
                          (values.valpengeluarankas / 100);
                      this.source[y].children[values.typePengeluaranKas][
                        "bln" + this.head.year + c
                      ][1] = totkl< 0 ? 0 : totkl
                        
                    } else {
                      let totkl = parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                        ) -
                        values.valnompengeluarankas < 0 ? 0 :
                          parseFloat(
                          this.source[y].children[values.typePengeluaranKas][
                            "bln" + this.head.year + c
                          ][1]
                          ) -
                          values.valnompengeluarankas;
                      this.source[y].children[values.typePengeluaranKas][
                        "bln" + this.head.year + c
                      ][1] = totkl < 0 ? 0 : totkl
                        
                    }
                  }
                }
              } else {
                if (values.typeChangePengeluaranKas == 0) {
                  if (values.option_value == "percentage") {
                    let totkl = parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      ) *
                        (values.valpengeluarankas / 100) +
                      parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      );
                    this.source[y].children[values.typePengeluaranKas][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1] = totkl < 0 ? 0 : totkl
                      
                  } else {
                    let totkl = parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      ) + values.valnompengeluarankas
                    this.source[y].children[values.typePengeluaranKas][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1] = totkl < 0 ?0 : totkl
                      ;
                  }
                } else {
                  if (values.option_value == "percentage") {
                    let totkl = parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      ) -
                      parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      ) *
                        (values.valpengeluarankas / 100);
                    this.source[y].children[values.typePengeluaranKas][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1] = totkl<0?0:totkl
                      
                  } else {
                    let totkl = parseFloat(
                        this.source[y].children[values.typePengeluaranKas][
                          "bln" + this.head.year + values.monthPengeluaranKas
                        ][1]
                      ) - values.valnompengeluarankas;
                    this.source[y].children[values.typePengeluaranKas][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1] = totkl<0?0 : totkl
                      
                  }
                }
              }

              //menghitung rekap pengeluaran
              let temp = 0;
              if (values.monthPengeluaranKas == 0) {
                for (let c = 1; c <= 12; c++) {
                  for (let z = 0; z < this.source[y].children.length; z++) {
                    temp += parseFloat(
                      this.source[y].children[z]["bln" + this.head.year + c][1]
                    );
                  }
                  this.source[y]["bln" + this.head.year + c][1] = temp;
                  temp = 0
                }
              } else {
                for (let z = 0; z < this.source[y].children.length; z++) {
                  temp += parseFloat(
                    this.source[y].children[z][
                      "bln" + this.head.year + values.monthPengeluaranKas
                    ][1]
                  );
                }
                this.source[y][
                  "bln" + this.head.year + values.monthPengeluaranKas
                ][1] = temp;
                temp = 0
              }
            }
          }
        }

        this.hitungallitem();
      });
      this.popoverEditCodeCostCenter = "";
      this.popupModalPendanaan.visible_pengeluarankas = false;
      this.formPengeluaranKas.resetFields();
    },
    submithutang() {
      this.formHutang.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        for (let y = 0; y < this.source.length; y++) {
          if (this.source[y].nameitem === "Hutang") {
            let temp = 0;
            this.source[y].children[values.typeHutang][
              "bln" + this.head.year + values.month_hutang
            ][1] = values.valhutang;
            for (let z = 0; z < this.source[y].children.length; z++) {
              temp += parseFloat(
                this.source[y].children[z][
                  "bln" + this.head.year + values.month_hutang
                ][1]
              );
            }
            this.source[y][
              "bln" + this.head.year + values.month_hutang
            ][1] = temp;
            break;
          }
        }
        this.hitungallitem();
      });
      this.popoverEditCodeCostCenter = "";
      this.popupModalPendanaan.visible_hutang = false;
      this.formHutang.resetFields();
    },
    submitheadPendanaan() {
      this.formHeadPendanaan.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        //validasi jika value>remaining
        let valrem = this.formHeadPendanaan.getFieldsValue();
        if (values.val_pendanaan > valrem.val_sisa) {
          this.displayMessage("grather-remaining");
          return;
        }

        let headvalues = 0;
        if (values.typePendanaan == 0) {
          headvalues = this.popupModalPendanaan.valuebankreturn;
        } else {
          headvalues = values.val_pendanaan;
        }

        if (parseFloat(headvalues) < 0) {
          this.displayMessage("grather-1");
        } else {
          this.loadingtable = true;
          this.popupModalPendanaan.bank = values.typePendanaan;
          this.popupModalPendanaan.month = values.monthPendanaan;
          this.popupModalPendanaan.bankname = values.bankname;
          this.popupModalPendanaan.val = parseFloat(headvalues);
          this.popupModalPendanaan.dtlmode = "add";

          if (
            values.payment_type == "flat" &&
            this.popupModalPendanaan.dtlmode == "add"
          ) {
            this.popupModalPendanaan.isflat = true;
            this.popupModalPendanaan.isprk = false;
          } else if (
            values.payment_type == "prk" &&
            this.popupModalPendanaan.dtlmode == "add"
          ) {
            this.popupModalPendanaan.isflat = false;
            this.popupModalPendanaan.isprk = true;
          }

          values.bankname = values.bankname ? values.bankname : "undefined";
          for (let y = 0; y < this.source.length; y++) {
            if (this.source[y].nameitem === "Pendanaan") {
              let temp = 0;
              if (
                this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][3] &&
                (this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][3].indexOf(values.bankname.toString() + ";") >= 0 ||
                  (this.source[y].children[values.typePendanaan][
                    "bln" + this.head.year + values.monthPendanaan
                  ][3].indexOf(values.bankname.toString() + ";") < 0 &&
                    this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][3] == "undefined;"))
              ) {
                let splitv = this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][3].split(";");
                let wg = 0;
                splitv.forEach((elemnt) => {
                  if (elemnt == values.bankname.toString()) {
                    let vprov = this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][4].split(";");
                    vprov[wg] = values.val_provisi;
                    this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][4] = Object.values(vprov).join(";");

                    let vptyp = this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][5].split(";");
                    vptyp[wg] = values.payment_type
                      ? values.payment_type == "flat"
                        ? 1
                        : 2
                      : 0;
                    this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][5] = Object.values(vptyp).join(";");

                    let vpen = this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][6].split(";");
                    vpen[wg] = values.val_pendanaan;
                    this.source[y].children[values.typePendanaan][
                      "bln" + this.head.year + values.monthPendanaan
                    ][6] = Object.values(vpen).join(";");

                    // replace values_hutang pada children sesuai head data
                    let llop= this.source[y].children[values.typePendanaan][
                      "children" + this.head.year + values.monthPendanaan
                    ].length
                    for (let iz = 0; iz < llop; iz++) {
                      if(this.source[y].children[values.typePendanaan][
                      "children" + this.head.year + values.monthPendanaan
                      ][iz].bankitem == values.bankname.toString()){
                        this.source[y].children[values.typePendanaan][
                      "children" + this.head.year + values.monthPendanaan
                      ][iz].value_hutang = headvalues
                      }
                    }
                  }
                  wg++;
                });
              } else {
                this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][3] =
                  (this.source[y].children[values.typePendanaan][
                    "bln" + this.head.year + values.monthPendanaan
                  ][3]
                    ? this.source[y].children[values.typePendanaan][
                        "bln" + this.head.year + values.monthPendanaan
                      ][3]
                    : "") +
                  values.bankname +
                  ";";
                this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][4] =
                  (this.source[y].children[values.typePendanaan][
                    "bln" + this.head.year + values.monthPendanaan
                  ][4]
                    ? this.source[y].children[values.typePendanaan][
                        "bln" + this.head.year + values.monthPendanaan
                      ][4]
                    : "") +
                  values.val_provisi +
                  ";";
                this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][5] =
                  (this.source[y].children[values.typePendanaan][
                    "bln" + this.head.year + values.monthPendanaan
                  ][5]
                    ? this.source[y].children[values.typePendanaan][
                        "bln" + this.head.year + values.monthPendanaan
                      ][5]
                    : "") +
                  (values.payment_type
                    ? values.payment_type == "flat"
                      ? 1 + ";"
                      : 2 + ";"
                    : 0 + ";");
                this.source[y].children[values.typePendanaan][
                  "bln" + this.head.year + values.monthPendanaan
                ][6] =
                  (this.source[y].children[values.typePendanaan][
                    "bln" + this.head.year + values.monthPendanaan
                  ][6]
                    ? this.source[y].children[values.typePendanaan][
                        "bln" + this.head.year + values.monthPendanaan
                      ][6]
                    : "") +
                  (values.val_pendanaan + ";");
              }

              let sumval = this.source[y].children[values.typePendanaan][
                "bln" + this.head.year + values.monthPendanaan
              ][6];
              let sumval2 = 0;
              sumval = sumval.split(";");
              sumval.forEach((element) => {
                sumval2 += parseFloat(element ? element : 0);
              });
              this.source[y].children[values.typePendanaan][
                "bln" + this.head.year + values.monthPendanaan
              ][1] = sumval2;

              for (let z = 0; z < this.source[y].children.length; z++) {
                temp += parseFloat(
                  this.source[y].children[z][
                    "bln" + this.head.year + values.monthPendanaan
                  ][1]
                );

                //menghitung rekap per children
                let trchild = 0;
                for (let xyz = 1; xyz <= 12; xyz++) {
                  trchild += parseFloat(
                    this.source[y].children[z]["bln" + this.head.year + xyz][1]
                  );
                }
                this.source[y].children[z]["rekap" + this.head.year] = trchild;

                //jika value 0 maka detilnya diset 0 semua
                if (parseFloat(headvalues) == 0) {
                  if (
                    this.source[y].children[z][
                      "children" + this.head.year + values.monthPendanaan
                    ]
                  ) {
                    let jt = this.source[y].children[z][
                      "children" + this.head.year + values.monthPendanaan
                    ].length;
                    for (let t = 0; t < jt; t++) {
                      let letresthn = this.source[y].children[z][
                        "children" + this.head.year + values.monthPendanaan
                      ][t].nameitem;
                      for (let q = 1; q <= 12; q++) {
                        let txtbnks = this.source[y].children[z][
                            "children" + this.head.year + values.monthPendanaan
                          ][t].bankitem
                        if (
                          (txtbnks == undefined ? "undefined" : txtbnks) ==
                          (values.bankname == undefined
                            ? "undefined"
                            : values.bankname)
                        ) {
                          this.source[y].children[z][
                            "children" + this.head.year + values.monthPendanaan
                          ][t]["bln" + letresthn + q][1] = 0;
                        }
                      }
                    }
                  }

                  for (let ya = 0; ya < this.source.length; ya++) {
                    if (this.source[ya].nameitem === "Hutang") {
                      for (
                        let ze = 0;
                        ze < this.source[ya].children.length;
                        ze++
                      ) {
                        if (
                          this.source[ya].children[ze].nameitem ===
                          "Hutang Tahun Berjalan"
                        ) {
                          this.source[ya].children[ze][
                            "bln" + this.head.year + values.monthPendanaan
                          ][1] = 0;
                        }
                        this.source[ya][
                          "bln" + this.head.year + values.monthPendanaan
                        ][1] = 0;
                      }
                    }
                  }

                  //jika tahun bayar sama dengan tahun pembiayaan maka masuk hutang tahun berjalan
                  let lops = [];
                  for (let aa1 = 0; aa1 < this.source.length; aa1++) {
                    if (this.source[aa1].nameitem === "Pendanaan") {
                      for (
                        let aa2 = 0;
                        aa2 < this.source[aa1].children.length;
                        aa2++
                      ) {
                        if (
                          this.source[aa1].children[aa2]["thn_bayar_hutang"] !==
                          undefined
                        ) {
                          for (
                            let aa3 = 0;
                            aa3 <
                            this.source[aa1].children[aa2]["thn_bayar_hutang"]
                              .length;
                            aa3++
                          ) {
                            lops[Object.keys(lops).length] = {
                              root: aa1,
                              child: aa2,
                              lbl: this.source[aa1].children[aa2][
                                "thn_bayar_hutang"
                              ][aa3],
                            };
                          }
                        }
                      }
                    }
                  }

                  if (Object.keys(lops).length > 0) {
                    //mencari lokasi hutang berjalan
                    let lokhtg_root = undefined;
                    let lokhtg_child = undefined;
                    for (let ab1 = 0; ab1 < this.source.length; ab1++) {
                      if (this.source[ab1].nameitem === "Hutang") {
                        for (
                          let ab2 = 0;
                          ab2 < this.source[ab1].children.length;
                          ab2++
                        ) {
                          if (
                            this.source[ab1].children[ab2].nameitem ==
                            "Hutang Tahun Berjalan"
                          ) {
                            lokhtg_root = ab1;
                            lokhtg_child = ab2;
                          }
                        }
                      }
                    }
                    //menjumlah hutang perbulan tiap tahun pendanaan
                    let longkeys = Object.keys(lops).length;
                    for (let bb1 = 1; bb1 <= 12; bb1++) {
                      let jumlahhtg = 0;
                      for (let bb2 = 0; bb2 < longkeys; bb2++) {
                        if (
                          this.source[lops[bb2].root].children[lops[bb2].child][
                            lops[bb2].lbl
                          ] !== undefined
                        ) {
                          for (
                            let bb3 = 0;
                            bb3 <
                            this.source[lops[bb2].root].children[
                              lops[bb2].child
                            ][lops[bb2].lbl].length;
                            bb3++
                          ) {
                            if (
                              this.source[lops[bb2].root].children[
                                lops[bb2].child
                              ][lops[bb2].lbl][bb3].nameitem == this.head.year
                            ) {
                              let thntmp = this.source[lops[bb2].root].children[
                                lops[bb2].child
                              ][lops[bb2].lbl][bb3].nameitem;
                              jumlahhtg += parseFloat(
                                this.source[lops[bb2].root].children[
                                  lops[bb2].child
                                ][lops[bb2].lbl][bb3]["bln" + thntmp + bb1][1]
                              );
                            }
                          }
                        }
                      }
                      //entri value pada detil hutang
                      this.source[lokhtg_root].children[lokhtg_child][
                        "bln" + this.head.year + bb1
                      ][1] = jumlahhtg;

                      //entri value pada rekap hutang
                      let longhtg2 = this.source[lokhtg_root].children.length;
                      let jmlrhtg = 0;
                      for (let cc1 = 0; cc1 < longhtg2; cc1++) {
                        jmlrhtg += parseFloat(
                          this.source[lokhtg_root].children[cc1][
                            "bln" + this.head.year + bb1
                          ][1]
                        );
                      }
                      this.source[lokhtg_root][
                        "bln" + this.head.year + bb1
                      ][1] = jmlrhtg;
                    }
                  }
                }
              }
              this.source[y][
                "bln" + this.head.year + values.monthPendanaan
              ][1] = temp;

              //insert detil bayar dengan nominal 0
              let createdtl = false
              let createexist = false
              if (
                this.source[y].children[values.typePendanaan][
                  "children" + this.head.year + values.monthPendanaan.toString()
                ] == undefined
              ) {
                createdtl = true
              }else{
                if (values.typePendanaan=="0"){
                  let l_dtl = this.source[y].children[values.typePendanaan][
                    "children" + this.head.year + values.monthPendanaan.toString()
                      ].length
                  createdtl = true
                  createexist = true
                  for (let indexs = 0; indexs < l_dtl; indexs++) {
                    const element = this.source[y].children[values.typePendanaan][
                    "children" + this.head.year + values.monthPendanaan.toString()
                      ][indexs].bankitem;
                    if (element == this.popupModalPendanaan.bankname){
                      createdtl = false
                      createexist = false

                      this.source[y].children[values.typePendanaan][
                        "children" + this.head.year + values.monthPendanaan.toString()
                          ][indexs].value_hutang = this.popupModalPendanaan.val
                    }
                  }
                }
              }
              if (createdtl){
                let blnc = [
                  {
                    key: nanoid(11),
                    nameitem: this.head.year.toString(),
                    bankitem: this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname :"undefined",
                    value_hutang: this.popupModalPendanaan.val,
                    type_pembayaran:
                      this.popupModalPendanaan.payment_type == "prk"
                        ? "2"
                        : "1",
                    editable: false,
                    root: false,
                    ["bln" + this.head.year + "1"]: [
                      "bln" + this.head.year + "1",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "2"]: [
                      "bln" + this.head.year + "2",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "3"]: [
                      "bln" + this.head.year + "3",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "4"]: [
                      "bln" + this.head.year + "4",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "5"]: [
                      "bln" + this.head.year + "5",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "6"]: [
                      "bln" + this.head.year + "6",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "7"]: [
                      "bln" + this.head.year + "7",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "8"]: [
                      "bln" + this.head.year + "8",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "9"]: [
                      "bln" + this.head.year + "9",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "10"]: [
                      "bln" + this.head.year + "10",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "11"]: [
                      "bln" + this.head.year + "11",
                      0,
                      0,
                    ],
                    ["bln" + this.head.year + "12"]: [
                      "bln" + this.head.year + "12",
                      0,
                      0,
                    ],
                  },
                ];

                for (let eq = 0; eq < this.source.length; eq++) {
                  if (this.source[eq].nameitem === "Pendanaan") {
                    if (createexist){
                      let lchi = this.source[eq].children[values.typePendanaan][
                        "children" +
                          this.head.year +
                          values.monthPendanaan.toString()
                      ].length
                      this.source[eq].children[values.typePendanaan][
                        "children" +
                          this.head.year +
                          values.monthPendanaan.toString()
                      ][lchi] = blnc[0];
                    }else{
                      this.source[eq].children[values.typePendanaan][
                        "children" +
                          this.head.year +
                          values.monthPendanaan.toString()
                      ] = blnc;

                      if (
                        this.source[eq].children[values.typePendanaan][
                          "thn_bayar_hutang"
                        ]
                      ) {
                          this.source[eq].children[values.typePendanaan][
                            "thn_bayar_hutang"
                          ][
                            Object.keys(
                              this.source[eq].children[values.typePendanaan][
                                "thn_bayar_hutang"
                              ]
                            ).length
                          ] =
                            "children" +
                            this.head.year +
                            values.monthPendanaan.toString();
                      } else {
                        this.source[eq].children[values.typePendanaan][
                          "thn_bayar_hutang"
                        ] = [
                          "children" +
                            this.head.year +
                            values.monthPendanaan.toString(),
                        ];
                      }
                    }
                  }
                }
              }
            }
          }
          this.hitungallitem();
          this.gentablebayar();

          //tampilkan default nominal jika value ada pada tabel pembayaran
          let form = this.formDtlPendanaan.getFieldsValue();
          //reset value terlebih dahulu sebelum update
          this.formDtlPendanaan.setFieldsValue({
            val_dtlbayar: 0,
          });
          this.popupModalPendanaan.dataPembayaran.forEach((element) => {
            if (
              element.key_bulan == form.monthdtlPendanaan &&
              element.tahun == form.dtltahun
            ) {
              this.formDtlPendanaan.setFieldsValue({
                val_dtlbayar: element.value,
              });
            }
          });
        }

        //memancing refresh table
        let jos = this.source[0]["rekap" + this.head.year];
        this.source[0]["rekap" + this.head.year] = 1;
        this.source[0]["rekap" + this.head.year] = jos;

        this.hitungallitem();
        this.gentablebayar();
        this.loadingtable = false;

        //tampilkan default nominal jika value ada pada tabel pembayaran
        let form = this.formDtlPendanaan.getFieldsValue();
        //reset value terlebih dahulu sebelum update
        this.formDtlPendanaan.setFieldsValue({
          val_dtlbayar: 0,
        });
        this.popupModalPendanaan.dataPembayaran.forEach((element) => {
          if (
            element.key_bulan == form.monthdtlPendanaan &&
            element.tahun == form.dtltahun
          ) {
            this.formDtlPendanaan.setFieldsValue({
              val_dtlbayar: element.value,
            });
          }
        });

        //menghitung remaining saldo bank
        if (values.typePendanaan == 0) {
          let sisaplafon = 0;
          // for (let hax = 0; hax < this.source.length; hax++) {
          //   if (this.source[hax].nameitem == "Pendanaan") {
          //     for (let hb = 0; hb < this.source[hax].children.length; hb++) {
          //       if (this.source[hax].children[hb].nameitem=="Bank"){
          //         for (let ab = 1; ab <=12; ab++) {
          //           if (this.source[hax].children[hb]["bln"+this.popupModalPendanaan.year+ab][3]){
          //             if ((this.source[hax].children[hb]["bln"+this.popupModalPendanaan.year+ab][3]).toString()==values.bankname){
          //               sisaplafon += parseFloat(this.source[hax].children[hb]["bln"+this.popupModalPendanaan.year+ab][1])
          //             }
          //           }
          //         }
          //       }
          //     }
          //   }
          // }
          //menghitung sisa remaining plafon
          for (let hax = 0; hax < this.source.length; hax++) {
            if (this.source[hax].nameitem == "Pendanaan") {
              for (let hb = 0; hb < this.source[hax].children.length; hb++) {
                if (this.source[hax].children[hb].nameitem == "Bank") {
                  for (let ab = 1; ab <= 12; ab++) {
                    if (
                      this.source[hax].children[hb][
                        "bln" + this.head.year + ab
                      ][3]
                    ) {
                      if (
                        this.source[hax].children[hb][
                          "bln" + this.head.year + ab
                        ][3].indexOf(values.bankname.toString()) >= 0
                      ) {
                        let txblb = this.source[hax].children[hb][
                          "bln" + this.head.year + ab
                        ][3];
                        txblb = txblb ? txblb.split(";") : undefined;
                        if (txblb !== undefined) {
                          let wg = 0;
                          txblb.forEach((element) => {
                            if (
                              element !== undefined &&
                              element == values.bankname.toString()
                            ) {
                              let isval = this.source[hax].children[hb][
                                "bln" + this.head.year + ab
                              ][6].split(";");
                              sisaplafon += parseFloat(isval[wg]);
                            }
                            wg++;
                          });
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          //check jumlah bayar hutang sama dengan jumlah hutang
          //this.listTahun.validatorUtang[0] = this.validasipendanaan();

          let index_1 = _.filter(this.listBank, {
            id_bank_plafon: values.bankname,
          });
          this.$nextTick(function () {
            this.formHeadPendanaan.setFieldsValue({
              val_plafon: parseFloat(index_1[0].value),
              val_sisa: parseFloat(index_1[0].value) - sisaplafon,
            });
          });
        }
      });
    },
    resetheadPendanaan() {
      this.formHeadPendanaan.validateFields((err) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
      });
      this.popupModalPendanaan.dtlmode = "reset";
      this.popupModalPendanaan.dataPembayaran = [];
      this.popupModalPendanaan.totalPembayaran = 0;
      this.popupModalPendanaan.val = 0;
      this.popupModalPendanaan.isprk = false;
      this.popupModalPendanaan.isflat = false;
      this.popupModalPendanaan.provisi = 0;
      this.popupModalPendanaan.lblprovisi = 0;
      this.popupModalPendanaan.valuebankreturn = 0;
      this.popupModalPendanaan.bankname = undefined;
      this.formDtlPendanaan.setFieldsValue({
        val_dtlbayar: 0,
      });
      this.formDtlPendanaan.resetFields();
      this.formDtlPendanaan2.resetFields();
      this.formHeadPendanaan.resetFields();

      let isiform = this.formHeadPendanaan.getFieldsValue();
      let form = {};
      if (isiform.length == undefined) {
        form = {
          bankname: this.popupModalPendanaan.bankname,
          monthPendanaan: this.popupModalPendanaan.month,
          typePendanaan: this.popupModalPendanaan.bank,
          val_pendanaan: this.popupModalPendanaan.val,
          payment_type: this.popupModalPendanaan.payment_type,
          val_plafon: 0,
          val_provisi: this.popupModalPendanaan.provisi,
          val_sisa: 0,
        };
      } else {
        form = isiform;
      }
      this.displayheadvalue(
        form.typePendanaan,
        form.monthPendanaan,
        form.bankname
      );
    },
    submitDtlPendanaan() {
      this.formDtlPendanaan.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.popupModalPendanaan.dtlmode == "add") {
          let hutangtitle = "thn_bayar_hutang";
          let canProcess = false;
          let tbln = parseFloat(values.monthdtlPendanaan);
          let thun = parseFloat(values.dtltahun);

          //menentukan pembuatan data temp pembayaran
          let lintasth = 1;
          if (values.duration > 0) {
            canProcess = true;
            for (let lth = 1; lth < values.duration; lth++) {
              if (tbln == 12) {
                lintasth += 1;
                thun += 1;
                tbln = 1;
              } else {
                tbln += 1;
              }
            }
          } else {
            if (
              parseFloat(values.dtltahun) -
                parseFloat(this.popupModalPendanaan.year) <
              0
            ) {
              canProcess = false;
              this.displayMessage("warning-valadatordDuration");
            } else {
              if (
                parseFloat(values.dtltahun) -
                  parseFloat(this.popupModalPendanaan.year) <
                  0 &&
                parseFloat(values.monthdtlPendanaan) -
                  parseFloat(this.popupModalPendanaan.month) <
                  0
              ) {
                canProcess = false;
                this.displayMessage("warning-valadatordDuration");
              } else {
                canProcess = true;
                let temph =
                  parseFloat(values.dtltahun2) - parseFloat(values.dtltahun);
                let slhth = (temph == 0 ? 1 : temph) * 12;
                let slhbl =
                  slhth +
                  (values.monthdtlPendanaan == 12
                    ? 12
                    : 12 - values.monthdtlPendanaan) -
                  (values.monthdtlPendanaan2 == 12
                    ? 12
                    : 12 - values.monthdtlPendanaan2);
                for (let lth = 0; lth <= slhbl; lth++) {
                  if (tbln == 12) {
                    lintasth += 1;
                    thun += 1;
                    tbln = 1;
                  } else {
                    tbln += 1;
                  }
                }
                tbln = tbln - 1;
              }
            }
          }
          if (canProcess) {
            let tahundtllop = values.dtltahun;
            let root = undefined;
            let stitle =
                "children" +
                this.popupModalPendanaan.year +
                this.popupModalPendanaan.month;

            //reset detil ke value 0 terlebih dahulu sebelum update
            for (let x = 0; x < this.source.length; x++) {
              if (this.source[x].nameitem == "Pendanaan") {
                let slbv = this.source[x].children[
                  this.popupModalPendanaan.bank
                ][stitle];
                if (slbv !== undefined) {
                  for (let tiq = 0; tiq < slbv.length; tiq++) {
                    if (this.source[x].children[
                              this.popupModalPendanaan.bank
                            ][stitle][tiq].bankitem == (this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined")){
                      for (let fror = 1; fror <= 12; fror++) {
                        let thcv = this.source[x].children[
                                this.popupModalPendanaan.bank
                              ][stitle][tiq].nameitem
                        this.source[x].children[
                          this.popupModalPendanaan.bank
                        ][stitle][tiq][
                          "bln" + thcv + fror.toString()
                        ][1] = 0
                      }
                    }
                  }
                }
              }
            }
            //
            for (let lopth = 1; lopth <= lintasth; lopth++) {
              let titbln = "bln" + tahundtllop;
              let blnc = [
                {
                  key: nanoid(11),
                  nameitem: tahundtllop,
                  bankitem: this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined",
                  value_hutang: this.popupModalPendanaan.val,
                  type_pembayaran:
                    this.popupModalPendanaan.payment_type == "prk" ? "2" : "1",
                  editable: false,
                  root: false,
                  [titbln + "1"]: [
                    titbln + "1",
                    parseFloat(tahundtllop + "01") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "01") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : "0",
                    0,
                  ],
                  [titbln + "2"]: [
                    titbln + "2",
                    parseFloat(tahundtllop + "02") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "02") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "3"]: [
                    titbln + "3",
                    parseFloat(tahundtllop + "03") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "03") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "4"]: [
                    titbln + "4",
                    parseFloat(tahundtllop + "04") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "04") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "5"]: [
                    titbln + "5",
                    parseFloat(tahundtllop + "05") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "05") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "6"]: [
                    titbln + "6",
                    parseFloat(tahundtllop + "06") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "06") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "7"]: [
                    titbln + "7",
                    parseFloat(tahundtllop + "07") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "07") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "8"]: [
                    titbln + "8",
                    parseFloat(tahundtllop + "08") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "08") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "9"]: [
                    titbln + "9",
                    parseFloat(tahundtllop + "09") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "09") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "10"]: [
                    titbln + "10",
                    parseFloat(tahundtllop + "10") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "10") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "11"]: [
                    titbln + "11",
                    parseFloat(tahundtllop + "11") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "11") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                  [titbln + "12"]: [
                    titbln + "12",
                    parseFloat(tahundtllop + "12") >=
                      parseFloat(
                        values.dtltahun +
                          (values.monthdtlPendanaan < 10
                            ? "0" + values.monthdtlPendanaan
                            : values.monthdtlPendanaan.toString())
                      ) &&
                    parseFloat(tahundtllop + "12") <=
                      parseFloat(
                        thun +
                          (tbln.toString().length == 1
                            ? "0" + tbln.toString()
                            : tbln.toString())
                      )
                      ? values.val_dtlbayar
                      : 0,
                    0,
                  ],
                },
              ];
              tahundtllop = parseFloat(tahundtllop) + 1;

              for (let x = 0; x < this.source.length; x++) {
                if (this.source[x].nameitem == "Pendanaan") {
                  root = x;
                  let slbl = this.source[x].children[
                    this.popupModalPendanaan.bank
                  ][stitle];
                  if (slbl !== undefined) {
                    let trig = true;
                    for (let tio = 0; tio < slbl.length; tio++) {
                      if (
                        this.source[x].children[this.popupModalPendanaan.bank][
                          stitle
                        ][tio].nameitem ==
                          tahundtllop - 1 &&
                        this.source[x].children[this.popupModalPendanaan.bank][
                          stitle
                        ][tio].bankitem == (this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined")
                      ) {
                        for (let itfor = 1; itfor <= 12; itfor++) {
                          this.source[x].children[
                            this.popupModalPendanaan.bank
                          ][stitle][tio][
                            "bln" + (tahundtllop - 1) + itfor.toString()
                          ][1] =
                            blnc[0][
                              "bln" + (tahundtllop - 1) + itfor.toString()
                            ][1];
                          if (
                            this.source[x].children[
                              this.popupModalPendanaan.bank
                            ][stitle][tio].nameitem ==
                            tahundtllop - 1 &&
                            this.source[x].children[
                              this.popupModalPendanaan.bank
                            ][stitle][tio].bankitem ==(this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined")
                          ) {
                            for (let itfor = 1; itfor <= 12; itfor++) {
                              this.source[x].children[
                                this.popupModalPendanaan.bank
                              ][stitle][tio][
                                "bln" + (tahundtllop - 1) + itfor.toString()
                              ][1] =
                                blnc[0][
                                  "bln" + (tahundtllop - 1) + itfor.toString()
                                ][1];
                            }
                            trig = false;
                          }
                        }
                      }
                    }

                    if (trig) {
                      let snum = this.source[x].children[
                        this.popupModalPendanaan.bank
                      ][stitle].length;
                      this.source[x].children[this.popupModalPendanaan.bank][
                        stitle
                      ][snum] = blnc[0];
                    }
                  } else {
                    this.source[x].children[this.popupModalPendanaan.bank][
                      stitle
                    ] = blnc;

                    if (
                      this.source[x].children[this.popupModalPendanaan.bank][
                        hutangtitle
                      ] !== undefined
                    ) {
                      let jmls = Object.keys(
                        this.source[x].children[this.popupModalPendanaan.bank][
                          hutangtitle
                        ]
                      ).length;
                      let cek = true;
                      for (let jm = 0; jm < jmls; jm++) {
                        if (
                          this.source[x].children[
                            this.popupModalPendanaan.bank
                          ][hutangtitle][jm] == stitle
                        ) {
                          cek = false;
                          //break
                        }
                      }
                      if (cek == true) {
                        this.source[x].children[this.popupModalPendanaan.bank][
                          hutangtitle
                        ][jmls] = stitle;
                      }
                    } else {
                      this.source[x].children[this.popupModalPendanaan.bank][
                        hutangtitle
                      ] = [stitle];
                    }
                  }
                }
              }
              //generate data table pembayaran
              this.gentablebayar();
            }
            //isi rekap hutang
            this.source[root].children[this.popupModalPendanaan.bank][
              "rekap" + this.popupModalPendanaan.year
            ] = this.getrekaphutang(this.popupModalPendanaan.bank);
          }
        }

        //check jumlah bayar hutang sama dengan jumlah hutang
        this.listTahun.validatorUtang[0] = this.validasipendanaan();

        //jika tahun bayar sama dengan tahun pembiayaan maka masuk hutang tahun berjalan
        let lops = [];
        for (let aa1 = 0; aa1 < this.source.length; aa1++) {
          if (this.source[aa1].nameitem === "Pendanaan") {
            for (let aa2 = 0; aa2 < this.source[aa1].children.length; aa2++) {
              if (
                this.source[aa1].children[aa2]["thn_bayar_hutang"] !== undefined
              ) {
                for (
                  let aa3 = 0;
                  aa3 <
                  this.source[aa1].children[aa2]["thn_bayar_hutang"].length;
                  aa3++
                ) {
                  lops[Object.keys(lops).length] = {
                    root: aa1,
                    child: aa2,
                    lbl: this.source[aa1].children[aa2]["thn_bayar_hutang"][
                      aa3
                    ],
                  };
                }
              }
            }
          }
        }

        if (Object.keys(lops).length > 0) {
          //mencari lokasi hutang berjalan
          let lokhtg_root = undefined;
          let lokhtg_child = undefined;
          for (let ab1 = 0; ab1 < this.source.length; ab1++) {
            if (this.source[ab1].nameitem === "Hutang") {
              for (let ab2 = 0; ab2 < this.source[ab1].children.length; ab2++) {
                if (
                  this.source[ab1].children[ab2].nameitem ==
                  "Hutang Tahun Berjalan"
                ) {
                  lokhtg_root = ab1;
                  lokhtg_child = ab2;
                }
              }
            }
          }
          //menjumlah hutang perbulan tiap tahun pendanaan
          let longkeys = Object.keys(lops).length;
          for (let bb1 = 1; bb1 <= 12; bb1++) {
            let jumlahhtg = 0;
            for (let bb2 = 0; bb2 < longkeys; bb2++) {
              if (
                this.source[lops[bb2].root].children[lops[bb2].child][
                  lops[bb2].lbl
                ] !== undefined
              ) {
                for (
                  let bb3 = 0;
                  bb3 <
                  this.source[lops[bb2].root].children[lops[bb2].child][
                    lops[bb2].lbl
                  ].length;
                  bb3++
                ) {
                  if (
                    this.source[lops[bb2].root].children[lops[bb2].child][
                      lops[bb2].lbl
                    ][bb3].nameitem == this.head.year
                  ) {
                    let thntmp = this.source[lops[bb2].root].children[
                      lops[bb2].child
                    ][lops[bb2].lbl][bb3].nameitem;
                    jumlahhtg += parseFloat(
                      this.source[lops[bb2].root].children[lops[bb2].child][
                        lops[bb2].lbl
                      ][bb3]["bln" + thntmp + bb1][1]
                    );
                  }
                }
              }
            }
            //entri value pada detil hutang
            this.source[lokhtg_root].children[lokhtg_child][
              "bln" + this.head.year + bb1
            ][1] = jumlahhtg;

            //entri value pada rekap hutang
            let longhtg2 = this.source[lokhtg_root].children.length;
            let jmlrhtg = 0;
            for (let cc1 = 0; cc1 < longhtg2; cc1++) {
              jmlrhtg += parseFloat(
                this.source[lokhtg_root].children[cc1][
                  "bln" + this.head.year + bb1
                ][1]
              );
            }
            this.source[lokhtg_root]["bln" + this.head.year + bb1][1] = jmlrhtg;
          }
        }
        this.hitungallitem();
      });
      this.formDtlPendanaan.resetFields();
    },
    submitDtlPendanaan2() {
      this.formDtlPendanaan2.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (this.popupModalPendanaan.dtlmode == "add") {
          let hutangtitle = "thn_bayar_hutang";
          let canProcess = false;

          //menentukan pembuatan data temp pembayaran
          let lintasth = 1;
          // if (values.duration > 0) {
          //   canProcess = true;
          //   for (let lth = 1; lth < values.duration; lth++) {
          //     if (tbln == 12) {
          //       lintasth += 1;
          //       thun += 1;
          //       tbln = 1;
          //     } else {
          //       tbln += 1;
          //     }
          //   }
          // } else {

          if (
            parseFloat(values.dtltahun) -
              parseFloat(this.popupModalPendanaan.year) <
            0
          ) {
            canProcess = false;
            this.displayMessage("warning-valadatordDuration");
          } else {
            if (
              parseFloat(values.dtltahun) -
                parseFloat(this.popupModalPendanaan.year) <
                0 &&
              parseFloat(values.monthdtlPendanaan) -
                parseFloat(this.popupModalPendanaan.month) <
                0
            ) {
              canProcess = false;
              this.displayMessage("warning-valadatordDuration");
            } else {
              canProcess = true;
            }
          }
          //}
          if (canProcess) {
            let root = 0;
            let tahundtllop = values.dtltahun;
            for (let lopth = 1; lopth <= lintasth; lopth++) {
              let titbln = "bln" + tahundtllop;
              let blnc = [
                {
                  key: nanoid(11),
                  nameitem: tahundtllop,
                  bankitem: this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined",
                  value_hutang: this.popupModalPendanaan.val,
                  type_pembayaran:
                    this.popupModalPendanaan.payment_type == "prk" ? "2" : "1",
                  editable: false,
                  root: false,
                  [titbln + "1"]: [
                    titbln + "1",
                    parseFloat(tahundtllop + "01") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : "0",
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "2"]: [
                    titbln + "2",
                    parseFloat(tahundtllop + "02") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "3"]: [
                    titbln + "3",
                    parseFloat(tahundtllop + "03") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "4"]: [
                    titbln + "4",
                    parseFloat(tahundtllop + "04") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "5"]: [
                    titbln + "5",
                    parseFloat(tahundtllop + "05") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "6"]: [
                    titbln + "6",
                    parseFloat(tahundtllop + "06") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "7"]: [
                    titbln + "7",
                    parseFloat(tahundtllop + "07") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "8"]: [
                    titbln + "8",
                    parseFloat(tahundtllop + "08") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "9"]: [
                    titbln + "9",
                    parseFloat(tahundtllop + "09") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "10"]: [
                    titbln + "10",
                    parseFloat(tahundtllop + "10") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "11"]: [
                    titbln + "11",
                    parseFloat(tahundtllop + "11") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                  [titbln + "12"]: [
                    titbln + "12",
                    parseFloat(tahundtllop + "12") ==
                    parseFloat(
                      values.dtltahun +
                        (values.monthdtlPendanaan < 10
                          ? "0" + values.monthdtlPendanaan
                          : values.monthdtlPendanaan.toString())
                    )
                      ? values.val_dtlbayar + values.bunga
                      : 0,
                    values.val_dtlbayar > 0
                      ? values.bunga
                        ? values.bunga
                        : 0
                      : 0,
                  ],
                },
              ];
              tahundtllop = parseFloat(tahundtllop) + 1;

              let stitle =
                "children" +
                this.popupModalPendanaan.year +
                this.popupModalPendanaan.month;
              for (let x = 0; x < this.source.length; x++) {
                if (this.source[x].nameitem == "Pendanaan") {
                  root = x;
                  let slbl = this.source[x].children[
                    this.popupModalPendanaan.bank
                  ][stitle];
                  if (slbl !== undefined) {
                    let trig = true;
                    for (let tio = 0; tio < slbl.length; tio++) {
                      if (
                        this.source[x].children[this.popupModalPendanaan.bank][
                          stitle
                        ][tio].nameitem ==
                          tahundtllop - 1 &&
                        this.source[x].children[this.popupModalPendanaan.bank][
                          stitle
                        ][tio].bankitem == (this.popupModalPendanaan.bankname ? this.popupModalPendanaan.bankname : "undefined")
                      ) {
                        if (
                          this.source[x].children[
                            this.popupModalPendanaan.bank
                          ][
                            "children" +
                              this.popupModalPendanaan.year +
                              this.popupModalPendanaan.month.toString()
                          ] !== undefined
                        ) {
                          if (
                            parseFloat(slbl[tio].nameitem) == values.dtltahun
                          ) {
                            this.source[x].children[
                              this.popupModalPendanaan.bank
                            ][stitle][tio][
                              "bln" +
                                (tahundtllop - 1) +
                                values.monthdtlPendanaan.toString()
                            ][1] =
                              blnc[0][
                                "bln" +
                                  (tahundtllop - 1) +
                                  values.monthdtlPendanaan.toString()
                              ][1];
                            this.source[x].children[
                              this.popupModalPendanaan.bank
                            ][stitle][tio][
                              "bln" +
                                (tahundtllop - 1) +
                                values.monthdtlPendanaan.toString()
                            ][2] =
                              blnc[0][
                                "bln" +
                                  (tahundtllop - 1) +
                                  values.monthdtlPendanaan.toString()
                              ][2];
                            trig = false;
                          }
                        }
                        // for (let itfor = 1; itfor <= 12; itfor++) {
                        //   this.source[x].children[this.popupModalPendanaan.bank][stitle][tio]["bln"+(tahundtllop-1)+(itfor.toString())][1]=
                        //   blnc[0]["bln"+(tahundtllop-1)+(itfor.toString())][1]
                        //   if (
                        //   this.source[x].children[this.popupModalPendanaan.bank][
                        //     stitle
                        //   ][tio].nameitem == tahundtllop-1
                        //   ) {
                        //     for (let itfor = 1; itfor <= 12; itfor++) {
                        //       // this.source[x].children[
                        //       //   this.popupModalPendanaan.bank
                        //       // ][stitle][tio][
                        //       //   "bln" + (tahundtllop-1) + itfor.toString()
                        //       // ][1] =
                        //       //   blnc[0][
                        //       //     "bln" + (tahundtllop - 1) + itfor.toString()
                        //       //   ][1];
                        //     }
                        //     trig = false;
                        //   }
                        // }
                      }
                    }

                    if (trig) {
                      let snum = this.source[x].children[
                        this.popupModalPendanaan.bank
                      ][stitle].length;
                      this.source[x].children[this.popupModalPendanaan.bank][
                        stitle
                      ][snum] = blnc[0];
                    }
                  } else {
                    this.source[x].children[this.popupModalPendanaan.bank][
                      stitle
                    ] = blnc;

                    if (
                      this.source[x].children[this.popupModalPendanaan.bank][
                        hutangtitle
                      ] !== undefined
                    ) {
                      let jmls = Object.keys(
                        this.source[x].children[this.popupModalPendanaan.bank][
                          hutangtitle
                        ]
                      ).length;
                      let cek = true;
                      for (let jm = 0; jm < jmls; jm++) {
                        if (
                          this.source[x].children[
                            this.popupModalPendanaan.bank
                          ][hutangtitle][jm] == stitle
                        ) {
                          cek = false;
                          //break
                        }
                      }
                      if (cek == true) {
                        this.source[x].children[this.popupModalPendanaan.bank][
                          hutangtitle
                        ][jmls] = stitle;
                      }
                    } else {
                      this.source[x].children[this.popupModalPendanaan.bank][
                        hutangtitle
                      ] = [stitle];
                    }
                  }
                }
              }
              //generate data table pembayaran
              this.gentablebayar();

              //isi rekap hutang
              //this.source[root].children[this.popupModalPendanaan.bank]["rekap"+this.popupModalPendanaan.year] =
              //  this.getrekaphutang(root,this.popupModalPendanaan.bank,this.popupModalPendanaan.year,this.popupModalPendanaan.month)
            }
            //isi rekap hutang
            this.source[root].children[this.popupModalPendanaan.bank][
              "rekap" + this.popupModalPendanaan.year
            ] = this.getrekaphutang(this.popupModalPendanaan.bank);
          }
        }

        //check jumlah bayar hutang sama dengan jumlah hutang
        this.listTahun.validatorUtang[0] = this.validasipendanaan();

        //jika tahun bayar sama dengan tahun pembiayaan maka masuk hutang tahun berjalan
        let lops = [];
        for (let aa1 = 0; aa1 < this.source.length; aa1++) {
          if (this.source[aa1].nameitem === "Pendanaan") {
            for (let aa2 = 0; aa2 < this.source[aa1].children.length; aa2++) {
              if (
                this.source[aa1].children[aa2]["thn_bayar_hutang"] !== undefined
              ) {
                for (
                  let aa3 = 0;
                  aa3 <
                  this.source[aa1].children[aa2]["thn_bayar_hutang"].length;
                  aa3++
                ) {
                  lops[Object.keys(lops).length] = {
                    root: aa1,
                    child: aa2,
                    lbl: this.source[aa1].children[aa2]["thn_bayar_hutang"][
                      aa3
                    ],
                  };
                }
              }
            }
          }
        }

        if (Object.keys(lops).length > 0) {
          //mencari lokasi hutang berjalan
          let lokhtg_root = undefined;
          let lokhtg_child = undefined;
          for (let ab1 = 0; ab1 < this.source.length; ab1++) {
            if (this.source[ab1].nameitem === "Hutang") {
              for (let ab2 = 0; ab2 < this.source[ab1].children.length; ab2++) {
                if (
                  this.source[ab1].children[ab2].nameitem ==
                  "Hutang Tahun Berjalan"
                ) {
                  lokhtg_root = ab1;
                  lokhtg_child = ab2;
                }
              }
            }
          }
          //menjumlah hutang perbulan tiap tahun pendanaan
          let longkeys = Object.keys(lops).length;
          for (let bb1 = 1; bb1 <= 12; bb1++) {
            let jumlahhtg = 0;
            for (let bb2 = 0; bb2 < longkeys; bb2++) {
              if (
                this.source[lops[bb2].root].children[lops[bb2].child][
                  lops[bb2].lbl
                ] !== undefined
              ) {
                for (
                  let bb3 = 0;
                  bb3 <
                  this.source[lops[bb2].root].children[lops[bb2].child][
                    lops[bb2].lbl
                  ].length;
                  bb3++
                ) {
                  if (
                    this.source[lops[bb2].root].children[lops[bb2].child][
                      lops[bb2].lbl
                    ][bb3].nameitem == this.head.year
                  ) {
                    let thntmp = this.source[lops[bb2].root].children[
                      lops[bb2].child
                    ][lops[bb2].lbl][bb3].nameitem;
                    jumlahhtg += parseFloat(
                      this.source[lops[bb2].root].children[lops[bb2].child][
                        lops[bb2].lbl
                      ][bb3]["bln" + thntmp + bb1][1]
                    );
                  }
                }
              }
            }
            //entri value pada detil hutang
            this.source[lokhtg_root].children[lokhtg_child][
              "bln" + this.head.year + bb1
            ][1] = jumlahhtg;

            //entri value pada rekap hutang
            let longhtg2 = this.source[lokhtg_root].children.length;
            let jmlrhtg = 0;
            for (let cc1 = 0; cc1 < longhtg2; cc1++) {
              jmlrhtg += parseFloat(
                this.source[lokhtg_root].children[cc1][
                  "bln" + this.head.year + bb1
                ][1]
              );
            }
            this.source[lokhtg_root]["bln" + this.head.year + bb1][1] = jmlrhtg;
          }
        }
        this.hitungallitem();
      });
      this.formDtlPendanaan2.resetFields();
    },
    gentablebayar() {
      this.popupModalPendanaan.dataPembayaran = [];
      this.popupModalPendanaan.totalPembayaran = 0;
      this.source.forEach((element) => {
        if (element.nameitem == "Pendanaan") {
          let tobj =
            element.children[this.popupModalPendanaan.bank][
              "children" +
                this.popupModalPendanaan.year.toString() +
                this.popupModalPendanaan.month
            ];
          if (tobj !== undefined) {
            let f =
              element.children[this.popupModalPendanaan.bank][
                "children" +
                  this.popupModalPendanaan.year.toString() +
                  this.popupModalPendanaan.month
              ].length;
            let num = 1;
            for (let i = 0; i < f; i++) {
              let iifbnk =
                element.children[this.popupModalPendanaan.bank][
                  "children" +
                    this.popupModalPendanaan.year.toString() +
                    this.popupModalPendanaan.month
                ][i].bankitem;
              if (
                iifbnk == "undefined" || iifbnk == undefined ||
                iifbnk == this.popupModalPendanaan.bankname
              ) {
                for (let j = 1; j <= 12; j++) {
                  let bln = "";
                  if (j == 1) {
                    bln = "January";
                  } else if (j == 2) {
                    bln = "February";
                  } else if (j == 3) {
                    bln = "March";
                  } else if (j == 4) {
                    bln = "April";
                  } else if (j == 5) {
                    bln = "May";
                  } else if (j == 6) {
                    bln = "June";
                  } else if (j == 7) {
                    bln = "July";
                  } else if (j == 8) {
                    bln = "August";
                  } else if (j == 9) {
                    bln = "September";
                  } else if (j == 10) {
                    bln = "October";
                  } else if (j == 11) {
                    bln = "November";
                  } else if (j == 12) {
                    bln = "December";
                  }
                  if (
                    element.children[this.popupModalPendanaan.bank][
                      "children" +
                        this.popupModalPendanaan.year.toString() +
                        this.popupModalPendanaan.month
                    ][i][
                      "bln" +
                        element.children[this.popupModalPendanaan.bank][
                          "children" +
                            this.popupModalPendanaan.year.toString() +
                            this.popupModalPendanaan.month
                        ][i].nameitem +
                        j.toString()
                    ][1] > 0
                  ) {
                    let descg = [
                      {
                        key:
                          element.children[this.popupModalPendanaan.bank][
                            "children" +
                              this.popupModalPendanaan.year.toString() +
                              this.popupModalPendanaan.month
                          ][i].nameitem +
                          j.toString() +
                          this.popupModalPendanaan.bankname,
                        no: num,
                        tahun:
                          element.children[this.popupModalPendanaan.bank][
                            "children" +
                              this.popupModalPendanaan.year.toString() +
                              this.popupModalPendanaan.month
                          ][i].nameitem,
                        key_bulan: j,
                        bulan: bln,
                        interest:
                          element.children[this.popupModalPendanaan.bank][
                            "children" +
                              this.popupModalPendanaan.year.toString() +
                              this.popupModalPendanaan.month
                          ][i][
                            "bln" +
                              element.children[this.popupModalPendanaan.bank][
                                "children" +
                                  this.popupModalPendanaan.year.toString() +
                                  this.popupModalPendanaan.month
                              ][i].nameitem +
                              j.toString()
                          ][2],
                        value:
                          element.children[this.popupModalPendanaan.bank][
                            "children" +
                              this.popupModalPendanaan.year.toString() +
                              this.popupModalPendanaan.month
                          ][i][
                            "bln" +
                              element.children[this.popupModalPendanaan.bank][
                                "children" +
                                  this.popupModalPendanaan.year.toString() +
                                  this.popupModalPendanaan.month
                              ][i].nameitem +
                              j.toString()
                          ][1] -
                          element.children[this.popupModalPendanaan.bank][
                            "children" +
                              this.popupModalPendanaan.year.toString() +
                              this.popupModalPendanaan.month
                          ][i][
                            "bln" +
                              element.children[this.popupModalPendanaan.bank][
                                "children" +
                                  this.popupModalPendanaan.year.toString() +
                                  this.popupModalPendanaan.month
                              ][i].nameitem +
                              j.toString()
                          ][2],
                      },
                    ];
                    this.popupModalPendanaan.dataPembayaran[num - 1] = descg[0];
                    num++;
                  }
                }
              }
            }
            this.hitungPembayaranPendanaan();
          } else {
            this.popupModalPendanaan.dataPembayaran = [];
          }
        }
      });
    },
    getrekaphutang(child) {
      let val = 0;

      for (let ab1 = 0; ab1 < this.source.length; ab1++) {
        if (this.source[ab1].nameitem === "Pendanaan") {
          let loop = this.source[ab1].children[child].thn_bayar_hutang.length;
          for (let i = 0; i < loop; i++) {
            let txt = this.source[ab1].children[child].thn_bayar_hutang[i];
            let loop2 = this.source[ab1].children[child][txt].length;
            for (let l = 0; l < loop2; l++) {
              let txtthun = this.source[ab1].children[child][txt][l].nameitem;
              for (let j = 1; j <= 12; j++) {
                val += parseFloat(
                  this.source[ab1].children[child][txt][l][
                    "bln" + txtthun + j
                  ][1]
                );
              }
            }
          }
        }
      }
      return val;
    },
    hitungPembayaranPendanaan() {
      let temp = 0;
      this.popupModalPendanaan.dataPembayaran.forEach((element) => {
        temp +=
          parseFloat(element.value) +
          (element.interest ? parseFloat(element.interest) : 0);
      });
      this.popupModalPendanaan.totalPembayaran = temp;
    },
    hitungallitem() {
      let temp = 0;
      let tempsaldoawal = 0;
      for (let y = 0; y < 12; y++) {
        for (let x = 0; x < this.source.length; x++) {
          if (y == 0 && x == 0 && this.source[y].nameitem == "Saldo Awal") {
            temp = parseFloat(
              this.source[x]["bln" + this.head.year + (y + 1)][1]
            );
            tempsaldoawal = temp;
          } else if (y > 0 && this.source[x].nameitem == "Saldo Awal") {
            this.source[x]["bln" + this.head.year + (y + 1)][1] = temp;
          } else if (this.source[x].nameitem == "Penerimaan Kas") {
            let a = this.source[x]["bln" + this.head.year + (y + 1)][1];
            temp += parseFloat(a);
          } else if (this.source[x].nameitem == "Pengeluaran Kas") {
            temp =
              temp -
              parseFloat(this.source[x]["bln" + this.head.year + (y + 1)][1]);
          } else if (this.source[x].nameitem == "Hutang") {
            temp =
              temp -
              parseFloat(this.source[x]["bln" + this.head.year + (y + 1)][1]);
          } else if (this.source[x].nameitem == "Saldo Sebelum Pendanaan") {
            this.source[x]["bln" + this.head.year + (y + 1)][1] = temp;
          } else if (this.source[x].nameitem == "Pendanaan") {
            temp += parseFloat(
              this.source[x]["bln" + this.head.year + (y + 1)][1]
            );
          } else if (this.source[x].nameitem == "Saldo Sesudah Pendanaan") {
            this.source[x]["bln" + this.head.year + (y + 1)][1] = temp;
          }
        }
      }

      for (let x = 0; x < this.source.length; x++) {
        let temp = 0;
        //hitung rekap lvl0
        for (let y = 1; y <= 12; y++) {
          temp += parseFloat(this.source[x]["bln" + this.head.year + y][1]);
        }
        if (this.source[x].nameitem == "Saldo Awal") {
          this.source[x]["rekap" + this.head.year] = tempsaldoawal;
        } else {
          this.source[x]["rekap" + this.head.year] = temp;
          //menghitung rekap lvl1
          if(this.source[x].children && this.source[x].children.length>0){
            let temp2 = 0
            for (let ch2 = 0; ch2 < this.source[x].children.length; ch2++) {
              for (let y2 = 1; y2 <= 12; y2++) {
                temp2 += parseFloat(this.source[x].children[ch2]["bln" + this.head.year + y2][1]);
              }
              this.source[x].children[ch2]["rekap"+ this.head.year] = temp2
              temp2=0
            
              //menghitung rekap lvl2
              if(this.source[x].children[ch2].children && this.source[x].children[ch2].children.length>0){
                let temp3 = 0
                for (let ch3 = 0; ch3 < this.source[x].children[ch2].children.length; ch3++) {
                  for (let y3 = 1; y3 <= 12; y3++) {
                    temp3 += parseFloat(this.source[x].children[ch2].children[ch3]["bln" + this.head.year + y3][1]);
                  }
                  this.source[x].children[ch2].children[ch3]["rekap"+ this.head.year] = temp3
                  temp3=0
                }
              }
            }
          }
        }

        //deteksi resetable
        let jmlchild = this.source[x].children
          ? this.source[x].children.length
          : 0;
        if (jmlchild == 0 && this.source[x].nameitem == "Saldo Awal") {
          for (let z = 1; z <= 1; z++) {
            if (
              parseFloat(this.source[x]["bln" + this.head.year + z][1]) !==
              parseFloat(this.source[x]["bln" + this.head.year + z][2])
            ) {
              this.source[x].resetable = true;
            }
          }
        } else if (jmlchild > 0) {
          for (let y = 0; y < jmlchild; y++) {
            for (let z = 1; z <= 12; z++) {
              if (
                parseFloat(
                  this.source[x].children[y]["bln" + this.head.year + z][1]
                ) !==
                parseFloat(
                  this.source[x].children[y]["bln" + this.head.year + z][2]
                )
              ) {
                this.source[x].children[y].resetable = true;
              }
            }
          }
        }
      }

      //hitung hutang tahun berikutnya
      let temp_hutangBerikutnya = 0;
      for (let x = 0; x < this.source.length; x++) {
        if (this.source[x].nameitem == "Pendanaan") {
          for (let pen = 0; pen < this.source[x].children.length; pen++) {
            if (this.source[x].children[pen].thn_bayar_hutang !== undefined) {
              let aj = Object.keys(
                this.source[x].children[pen].thn_bayar_hutang
              ).length;
              for (let pen2 = 0; pen2 < aj; pen2++) {
                let child1 = this.source[x].children[pen].thn_bayar_hutang[
                  pen2
                ];
                for (let pen4 = 1; pen4 <= 12; pen4++) {
                  //looping 2x
                  //console.log("looping 2x");
                  let penj = this.source[x].children[pen][child1]
                    ? this.source[x].children[pen][child1].length
                    : 0;
                  for (let pen3 = 0; pen3 < penj; pen3++) {
                    if (
                      this.source[x].children[pen][child1][pen3].nameitem !==
                      this.head.year
                    ) {
                      let tempjdl = this.source[x].children[pen][child1][pen3]
                        .nameitem;
                      temp_hutangBerikutnya += parseFloat(
                        this.source[x].children[pen][child1][pen3][
                          "bln" + tempjdl.toString() + pen4
                        ][1]
                      );
                    }
                  }
                }
              }
            }
          }
          break;
        }
      }
      this.listTahun.hutang_tahun_berikutnya = temp_hutangBerikutnya;
      this.listTahun.validatorUtang = [this.validasipendanaan()];
      //console.log("hitung hutang");
      //console.log(temp_hutangBerikutnya);
    },
    handleType() {},
    handleMonth() {},
    handleOptionValuePengeluaranKas(val) {
      if (val.target.value == "nominal") {
        this.popupModalPendanaan.optionValuePengeluaranKas = "nominal";
      } else {
        this.popupModalPendanaan.optionValuePengeluaranKas = "percentage";
      }
    },
    handleMenuClick(e) {
      let identText = this.HeaderisClicked;
      let items = e.key.split(":");
      if (items[0] == "rekap") {
        if (items[1] == "hide") {
          identText = identText.replace("rekap:hide", "rekap:unhide");
          this.HeaderisClicked = identText.replace(
            items[0] + ":hide" + items[1],
            items[0] + ":unhide"
          );
        } else {
          identText = identText.replace("rekap:unhide", "rekap:hide");
          this.HeaderisClicked = identText.replace(":unhide", ":hide");
        }
      }

      if (items[0] !== "rekap" && items[3] == "unhide") {
        this.$notification.warning({
          message: "Warning Message!",
          description: "You can't expand when you collapse/expand all year!",
        });
      }

      if (items[0] !== "rekap" && items[3] == "hide") {
        if (items[1] == "hide") {
          this.HeaderisClicked = identText.replace(
            items[0] + ":" + items[1],
            items[0] + ":unhide"
          );
        } else {
          this.HeaderisClicked = identText.replace(
            items[0] + ":" + items[1],
            items[0] + ":hide"
          );
        }
      }

      this.getcolomns();
    },
    getcolomns() {
      let col = [];
      let iff = this.HeaderisClicked.split(";");
      if (iff[0] == "rekap:unhide") {
        let splitiff = iff[0].split(":");
        this.kolom[1].children = this.kolom[1].children_asal;
        let tempkolom = this.kolom[1];

        for (let y = 0; y < this.kolom[1].children.length; y++) {
          if (tempkolom.children[y].className.indexOf("alltahun") >= 0) {
            if (splitiff[1] == "unhide") {
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className = "unhide alltahun";
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className = "unhide alltahun";
              col.push(tempkolom.children[y]);
            } else {
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className = "hide alltahun";
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className = "hide alltahun";
              col.push(tempkolom.children[y]);
            }
          }
          if (tempkolom.children[y].className.indexOf("kolom") >= 0) {
            if (splitiff[1] == "hide") {
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className.replace("unhide", "hide");
              tempkolom.children[y].className = tempkolom.children[
                y
              ].className.replace("hide", "unhide");
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className.replace("unhide", "hide");
              tempkolom.children[y].children[0].className = tempkolom.children[
                y
              ].children[0].className.replace("hide", "unhide");
              col.push(tempkolom.children[y]);
            }
          }
          if (tempkolom.children[y].className == "relative") {
            col.push(tempkolom.children[y]);
          }
        }
        this.kolom[1].children = col;
      } else {
        this.kolom[1].children = this.kolom[1].children_asal;
        let tempkolom = this.kolom[1];
        for (let x = 1; x < iff.length; x++) {
          let tempthn = iff[x].split(":");

          for (let y = 0; y < this.kolom[1].children.length; y++) {
            if (
              tempthn[1] == "hide" &&
              tempkolom.children[y].className.indexOf(
                "th" + tempthn[0] + "rekap kolom"
              ) >= 0
            ) {
              tempkolom.children[y].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              tempkolom.children[y].children[0].className =
                "unhide header th" + tempthn[0] + "rekap kolom";
              col.push(tempkolom.children[y]);
            }

            if (
              tempthn[1] == "unhide" &&
              tempkolom.children[y].className == "unhide header th" + tempthn[0]
            ) {
              if (
                tempkolom.children[y].className.indexOf(
                  "header th" + tempthn[0]
                ) >= 0
              ) {
                tempkolom.children[y].className =
                  "unhide header th" + tempthn[0];
                tempkolom.children[y].children[0].className =
                  "unhide header th" + tempthn[0];
                col.push(tempkolom.children[y]);
              }
            }

            if (tempkolom.children[y].className == "relative") {
              col.push(tempkolom.children[y]);
            }
          }
        }
        this.kolom[1].children = col;
        tempkolom = [];
        col = [];
      }
    },
    hideunhideALL() {
      var elmntThn = document.getElementById("HeaderisClicked").value;
      this.kolom[0].showcolumn = elmntThn;
    },
    filterOptionperuntukan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleperuntukan(val) {
      let tempsuggest = _.filter(
        this.datatree,
        (item) => item.key.indexOf(val) >= 0
      );
      this.suggestOpsiPeruntukan = tempsuggest[0].children;
    },
    onExpand(expandedKeys, info) {
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = info.key;
      this.autoExpandParent = false;
    },
    onCellChange(key, dataIndex, value) {
      let tmpsrc = this.source;
      let splitcode = key.split(";");

      let index_1 = _.findIndex(
        this.source[0].children,
        (e) => {
          return e.key == splitcode[0];
        },
        0
      );
      if (splitcode.length == 2) {
        //child 2 level
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == key;
          },
          0
        );
        tmpsrc[0].children[index_1].children[index_2][dataIndex] = [
          dataIndex,
          value,
        ];
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
      if (splitcode.length == 3) {
        //child 3 level
        let params = splitcode[0] + ";" + splitcode[1];
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == params;
          },
          0
        );
        let index_3 = _.findIndex(
          this.source[0].children[index_1].children[index_2].children,
          (e) => {
            return e.key == key;
          },
          0
        );
        tmpsrc[0].children[index_1].children[index_2].children[index_3][
          dataIndex
        ] = [dataIndex, value];
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
    },
    showPopOverEditCostcenter(name) {
      if (name.nameitem == "Pendanaan") {
        this.formHeadPendanaan.resetFields();
        this.formDtlPendanaan.resetFields();

        this.popoverEditCodeCostCenter = null;
        this.popupModalPendanaan.visible_pendanaan = true;
        this.popupModalPendanaan.title = "Hutang Tahun Berjalan";
        this.popupModalPendanaan.title2 = "Detil Pembayaran Hutang";
        this.popupModalPendanaan.title3 = "Pembayaran Hutang";
        this.popupModalPendanaan.year = this.head.year;
        this.popupModalPendanaan.bank = 0;
        this.popupModalPendanaan.valuebankreturn = 0;
        this.popupModalPendanaan.month = 1;
        this.popupModalPendanaan.bankname = undefined;
        this.totalPembayaran = 0;
        this.popupModalPendanaan.isflat = undefined;
        this.popupModalPendanaan.isprk = undefined;
        this.popupModalPendanaan.dtlmode = "reset";

        this.source.forEach((element) => {
          if (element.nameitem == "Pendanaan") {
            for (let y = 0; y < element.children.length; y++) {
              if (element.children[y].nameitem == "Bank") {
                this.popupModalPendanaan.val =
                  element.children[y]["bln" + this.head.year + "1"][1];
                if (element.children[y]["bln" + this.head.year + "1"][3]) {
                  let bnkdefeult = element.children[y][
                    "bln" + this.head.year + "1"
                  ][3].split(";");
                  this.popupModalPendanaan.bankname = bnkdefeult[0].toString();
                  this.displayheadvalue(
                    this.popupModalPendanaan.bank,
                    this.popupModalPendanaan.month,
                    bnkdefeult[0].toString()
                  );
                }
                break;
              }
            }
          }
          if (element.nameitem == "Hutang") {
            let tobj =
              element.children[this.popupModalPendanaan.bank][
                "children" +
                  this.popupModalPendanaan.year.toString() +
                  this.popupModalPendanaan.month
              ];
            if (tobj !== undefined) {
              let f =
                element.children[this.popupModalPendanaan.bank][
                  "children" +
                    this.popupModalPendanaan.year.toString() +
                    this.popupModalPendanaan.month
                ].length;
              let num = 1;
              for (let i = 0; i < f; i++) {
                for (let j = 1; j <= 12; j++) {
                  let bln = "";
                  if (j == 1) {
                    bln = "January";
                  } else if (j == 2) {
                    bln = "February";
                  } else if (j == 3) {
                    bln = "March";
                  } else if (j == 4) {
                    bln = "April";
                  } else if (j == 5) {
                    bln = "May";
                  } else if (j == 6) {
                    bln = "June";
                  } else if (j == 7) {
                    bln = "July";
                  } else if (j == 8) {
                    bln = "August";
                  } else if (j == 9) {
                    bln = "September";
                  } else if (j == 10) {
                    bln = "October";
                  } else if (j == 11) {
                    bln = "November";
                  } else if (j == 12) {
                    bln = "December";
                  }
                  let descg = [
                    {
                      key:
                        element.children[this.popupModalPendanaan.bank][
                          "children" +
                            this.popupModalPendanaan.year.toString() +
                            this.popupModalPendanaan.month
                        ][i].nameitem + j.toString(),
                      no: num,
                      tahun:
                        element.children[this.popupModalPendanaan.bank][
                          "children" +
                            this.popupModalPendanaan.year.toString() +
                            this.popupModalPendanaan.month
                        ][i].nameitem,
                      key_bulan: j,
                      bulan: bln,
                      value:
                        element.children[this.popupModalPendanaan.bank][
                          "children" +
                            this.popupModalPendanaan.year.toString() +
                            this.popupModalPendanaan.month
                        ][i][
                          "bln" +
                            element.children[this.popupModalPendanaan.bank][
                              "children" +
                                this.popupModalPendanaan.year.toString() +
                                this.popupModalPendanaan.month
                            ][i].nameitem +
                            j.toString()
                        ][1],
                    },
                  ];
                  this.popupModalPendanaan.dataPembayaran[num - 1] = descg[0];
                  num++;
                }
              }
              this.hitungPembayaranPendanaan();
            } else {
              this.popupModalPendanaan.dataPembayaran = [];
            }
            this.gentablebayar();
          }
        });
      } else {
        this.popupModalPendanaan.visible_title = name.nameitem;
        if (name.nameitem == "Saldo") {
          this.popupModalPendanaan.visible_saldo = true;
        } else if (name.nameitem == "Saldo") {
          this.popupModalPendanaan.visible_saldoawal = true;
        } else if (name.nameitem == "Penerimaan Kas") {
          this.popupModalPendanaan.visible_penerimaankas = true;
        } else if (name.nameitem == "Pengeluaran Kas") {
          this.popupModalPendanaan.visible_pengeluarankas = true;
          this.popupModalPendanaan.optionValuePengeluaranKas = "nominal";
        } else if (name.nameitem == "Hutang") {
          this.popupModalPendanaan.visible_hutang = true;
        } else {
          this.popupModalPendanaan.visible_other = true;
        }
        this.editTextCostCenter = name.nameitem;
        this.editCodeCostCenter = name.key;
        this.popoverEditCodeCostCenter = name.key;
      }
    },
    resetdataItem(name) {
      this.loadingtable = true;
      for (let y = 0; y < this.source.length; y++) {
        let jmlchild = this.source[y].children
          ? this.source[y].children.length
          : 0;
        if (jmlchild == 0 && name.nameitem == "Saldo Awal") {
          for (let k = 0; k < this.source.length; k++) {
            if (this.source[k].key === name.key) {
              for (let c = 1; c <= 1; c++) {
                let temp = 0;
                this.source[k]["bln" + this.head.year + c][1] = this.source[k][
                  "bln" + this.head.year + c
                ][2];
                for (let l = 1; l < 12; l++) {
                  temp += parseFloat(
                    this.source[k]["bln" + this.head.year + l][1]
                  );
                }
                this.source[k]["rekap" + this.head.year] = temp;
                this.source[k].resetable = false;
              }
              break;
            }
          }
          break;
        } else if (jmlchild > 0) {
          for (let z = 0; z < jmlchild; z++) {
            if (this.source[y].children[z].key === name.key) {
              for (let c = 1; c <= 12; c++) {
                //reset data sesuai baris yang diklik reset
                let temp = 0;
                this.source[y].children[z].resetable = false;
                this.source[y].children[z][
                  "bln" + this.head.year + c
                ][1] = this.source[y].children[z][
                  "bln" + this.head.year + c
                ][2];
                if (this.source[y].children[z]["bln" + this.head.year + c][6]) {
                  let jval = this.source[y].children[z][
                    "bln" + this.head.year + c
                  ][6].split(";");
                  let jcount = 0;
                  let jtext = "";
                  jval.forEach((elment) => {
                    if (elment !== "" && elment !== undefined) {
                      jtext +=
                        jcount == 0
                          ? this.source[y].children[z][
                              "bln" + this.head.year + c
                            ][2] + ";"
                          : "0;";
                      jcount++;
                    }
                  });
                  this.source[y].children[z][
                    "bln" + this.head.year + c
                  ][6] = jtext;
                }
                for (let z = 0; z < this.source[y].children.length; z++) {
                  temp += parseFloat(
                    this.source[y].children[z]["bln" + this.head.year + c][1]
                  );
                }
                this.source[y]["bln" + this.head.year + c][1] = temp;
              }
            }
            
            if (
              this.source[y].children[z].key === name.key &&
              (name.nameitem == "Bank" || name.nameitem == "Non Bank")
            ) {
              //reset Hutang tahun berjalan jika klik reset Bank / Non Bank
              for (let d = 0; d < this.source.length; d++) {
                if (this.source[d].nameitem == "Hutang") {
                  let jmllengthhutang = this.source[d].children.length;
                  for (let e = 0; e < jmllengthhutang; e++) {
                    if (
                      this.source[d].children[e].nameitem ==
                      "Hutang Tahun Berjalan"
                    ) {
                      for (let c = 1; c <= 12; c++) {
                        //reset data sesuai baris yang diklik reset
                        let temp = 0;
                        this.source[d].children[e].resetable = false;
                        this.source[d].children[e][
                          "bln" + this.head.year + c
                        ][1] = this.source[d].children[e][
                          "bln" + this.head.year + c
                        ][2];
                        for (
                          let z = 0;
                          z < this.source[d].children.length;
                          z++
                        ) {
                          temp += parseFloat(
                            this.source[d].children[z][
                              "bln" + this.head.year + c
                            ][1]
                          );
                        }
                        this.source[d]["bln" + this.head.year + c][1] = temp;
                      }
                      break;
                    }
                  }
                }
                if (this.source[d].nameitem == "Pendanaan") {
                  let jmllengthhutang = this.source[d].children.length;
                  for (let e = 0; e < jmllengthhutang; e++) {
                    //reset detil bayar
                    if (
                      this.source[d].children[e]["thn_bayar_hutang"] !==
                        undefined &&
                      this.source[d].children[e].nameitem == name.nameitem
                    ) {
                      let jmlchild = this.source[d].children[e].thn_bayar_hutang
                        ? this.source[d].children[e].thn_bayar_hutang.length
                        : 0;
                      for (let f = 0; f < jmlchild; f++) {
                        let lblidchild = this.source[d].children[e][
                          "thn_bayar_hutang"
                        ][f];
                        let lopbln = this.source[d].children[e][lblidchild]
                          .length;

                        let csbank = (this.source[d].children[e][lblidchild
                          .replace("children","bln")][6]).split(";")
                          console.log("csbank",lopbln,csbank)
                        for (let g = 0; g < lopbln; g++) {
                          for (let h = 1; h <= 12; h++) {
                            let lblthn = this.source[d].children[e][lblidchild][
                              g
                            ].nameitem;
                            this.source[d].children[e][lblidchild][g][
                              "bln" + lblthn.toString() + h
                            ][1] = 0;
                          }
                          this.source[d].children[e][lblidchild][g].value_hutang=parseFloat(csbank[g])
                        }
                      }
                    }

                    //reset rekap
                    let qwtot = 0;
                    for (let qw = 1; qw <= 12; qw++) {
                      qwtot += parseFloat(
                        this.source[d].children[e][
                          "bln" + this.head.year + qw.toString()
                        ][1]
                      );
                    }
                    this.source[d].children[e][
                      "rekap" + this.head.year
                    ] = qwtot;
                  }
                }
              }
              //reset Hutang tahun berjalan jika klik reset Bank / Non Bank
              let rekphutang = [];
              let l_root = 0;
              let l_child = 0;
              for (let d = 0; d < this.source.length; d++) {
                if (this.source[d].nameitem == "Hutang") {
                  let jmllenthtg = this.source[d].children.length;
                  for (let da = 0; da < jmllenthtg; da++) {
                    if (
                      this.source[d].children[da].nameitem ==
                      "Hutang Tahun Berjalan"
                    ) {
                      l_root = d;
                      l_child = da;
                    }
                  }
                }
                if (this.source[d].nameitem == "Pendanaan") {
                  let jmllengthhutang = this.source[d].children.length;
                  for (let e = 0; e < jmllengthhutang; e++) {
                    if (
                      this.source[d].children[e]["thn_bayar_hutang"] !==
                      undefined
                    ) {
                      let jmlchild = this.source[d].children[e].thn_bayar_hutang
                        ? this.source[d].children[e].thn_bayar_hutang.length
                        : 0;
                      for (let f = 0; f < jmlchild; f++) {
                        let lblidchild = this.source[d].children[e][
                          "thn_bayar_hutang"
                        ][f];
                        let lengthchild = this.source[d].children[e][lblidchild]
                          .length;
                        for (let g = 0; g < lengthchild; g++) {
                          rekphutang[rekphutang.length] = {
                            root: d,
                            child: e,
                            bank:this.source[d].children[e][lblidchild][g]
                              .bankitem,
                            tahun: this.source[d].children[e][lblidchild][g]
                              .nameitem,
                            label: lblidchild,
                          };
                        }
                      }
                    }
                  }
                }
              }
              for (let ee1 = 1; ee1 <= 12; ee1++) {
                let tolstemp = 0;
                for (let dd1 = 0; dd1 < rekphutang.length; dd1++) {
                  let totlchilds = this.source[rekphutang[dd1].root].children[
                    rekphutang[dd1].child
                  ][rekphutang[dd1].label].length;
                  for (let ff1 = 0; ff1 < totlchilds; ff1++) {
                    if (
                      this.source[rekphutang[dd1].root].children[
                        rekphutang[dd1].child
                      ][rekphutang[dd1].label][ff1].nameitem == this.head.year
                    ) {
                      if (
                        this.source[rekphutang[dd1].root].children[
                          rekphutang[dd1].child
                        ][rekphutang[dd1].label][ff1][
                          "bln" + rekphutang[dd1].tahun + ee1
                        ]
                      ) {
                        if(this.source[rekphutang[dd1].root].children[
                              rekphutang[dd1].child
                            ][rekphutang[dd1].label][ff1].bankitem==rekphutang[dd1].bank){
                          tolstemp += parseFloat(
                            this.source[rekphutang[dd1].root].children[
                              rekphutang[dd1].child
                            ][rekphutang[dd1].label][ff1][
                              "bln" + rekphutang[dd1].tahun + ee1
                            ][1]
                          );
                        }
                      }
                    }
                  }
                }
                this.source[l_root].children[l_child][
                  "bln" + this.head.year + ee1
                ][1] = tolstemp;
              }

              for (let d = 0; d < this.source.length; d++) {
                if (this.source[d].nameitem == "Hutang") {
                  let jmllengthhutang = this.source[d].children.length;
                  for (let e = 0; e < jmllengthhutang; e++) {
                    if (
                      this.source[d].children[e].nameitem ==
                      "Hutang Tahun Berjalan"
                    ) {
                      for (let c = 1; c <= 12; c++) {
                        //reset data sesuai baris yang diklik reset
                        let temp = 0;
                        for (
                          let z = 0;
                          z < this.source[d].children.length;
                          z++
                        ) {
                          temp += parseFloat(
                            this.source[d].children[z][
                              "bln" + this.head.year + c
                            ][1]
                          );
                        }
                        this.source[d]["bln" + this.head.year + c][1] = temp;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.hitungallitem();

      //memancing refresh table
      let jos = this.source[0]["rekap" + this.head.year];
      this.source[0]["rekap" + this.head.year] = 1;
      this.source[0]["rekap" + this.head.year] = jos;

      this.loadingtable = false;
    },
    simpanEditCostcenter() {
      let tmpsrc = this.source;
      let splitcode = this.editCodeCostCenter.split(";");

      let index_1 = _.findIndex(
        this.source[0].children,
        (e) => {
          return e.key == splitcode[0];
        },
        0
      );
      if (splitcode.length == 2) {
        //child 2 level
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == this.editCodeCostCenter;
          },
          0
        );
        tmpsrc[0].children[index_1].children[
          index_2
        ].nameitem = this.editTextCostCenter;
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
      if (splitcode.length == 3) {
        //child 3 level
        let params = splitcode[0] + ";" + splitcode[1];
        let index_2 = _.findIndex(
          this.source[0].children[index_1].children,
          (e) => {
            return e.key == params;
          },
          0
        );
        let index_3 = _.findIndex(
          this.source[0].children[index_1].children[index_2].children,
          (e) => {
            return e.key == this.editCodeCostCenter;
          },
          0
        );
        tmpsrc[0].children[index_1].children[index_2].children[
          index_3
        ].nameitem = this.editTextCostCenter;
        this.source = tmpsrc;
        this.popoverEditCodeCostCenter = null;
      }
    },
    closePopOver() {
      this.popoverEditCodeCostCenter = null;
    },
    handleExport(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table.nodeType)
        table = document.getElementsByClassName("ant-table-scroll");
      let ctx = { worksheet: name || "Worksheet", table: table[0].innerHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "Simulasi.xls";
      a.click();
    },
    handleSubmitPassword() {
      this.formPassword.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (CryptoJS.MD5(values.password) == this.getAuth.password) {
          this.visibleFormPass = false;
          this.formPassword.resetFields();
          // lakukan loading pada tombol download
          this.loadingExport = true;

          axios({
            method: "get",
            url: this.$serviceUrl + "simulasi/export",
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "X-API-KEY": this.getAuth.apikey,
            },
            params: {
              url: window.location.href,
              tlc: this.getAuth.username,
              password: btoa(values.password),
            },
          })
            .then((response) => {
              window.open(
                this.$serviceUrl + response.data.url_download,
                "_blank"
              );
              this.loadingExport = false;
            })
            .catch((err) => {
              console.log(err);
              this.loadingExport = false;
            });
        } else {
          this.displayMessage("wrong-password");
        }
      });
    },
  },
};
</script>

<style lang="less">
.textbottom_red {
  border-bottom: 2px solid red;
  display: block;
}
.textbottom_green {
  border-bottom: 2px solid green;
  display: block;
}
.hide,
.hidecell {
  display: none;
}
/* .ant-table-row-level-0{background-color: rgba(26, 188, 156, 0.3);}
.ant-table-row-level-1{background-color: rgba(26, 188, 156, 0.2);}
.ant-table-row-level-2{background-color: rgba(26, 188, 156, 0.1);}
.ant-table-row-level-3{background-color: rgba(26, 188, 156, 0.05);} */

.ant-table-thead {
  background-color: rgba(245, 245, 245, 1);
}

.editable-cell {
  position: relative;
}

.editable-cell-input-wrapper {
  padding-right: 24px;
}

/* .editable-cell-text-wrapper {
  padding: 5px 24px 5px 5px;
} */

.editable-cell-icon,
.editable-cell-icon-check {
  position: relative;
  right: 0;
  width: 20px;
  cursor: pointer;
}

.editable-cell-icon {
  line-height: 18px;
  display: none;
  float: left;
}

.editable-cell-icon-check {
  line-height: 28px;
  position: absolute;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
  color: #108ee9;
}

.editable-add-btn {
  margin-bottom: 8px;
}

input[className="editcell"] {
  height: auto;
  padding: 0px 5px;
}

.editcell-wrap {
  text-align: right;
}

.editcell-action {
  text-align: center;
}

// .m-list-title {
// }

.table-content {
  display: flex;
  flex-direction: column;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    min-height: 50px;
  }

  .center {
    flex: 1;
  }
}

.footer-calc {
  display: flex;
  justify-content: flex-end;
  .ant-row{
    width: 400px;

  }
}
</style>
